// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base text color for the whole shadow root — not just .ps-panel — because
   some overlays (confirm/alert dialogs, the step-config modal, the function
   detail popup) are appended directly to this.shadowRoot as siblings of
   .ps-panel rather than nested inside it, so they never inherited .ps-panel's
   own color rule and fell back to the page's ambient (non-dark) text color. */
:host {
    color: var(--text-primary, #333);
}

/* Dark theme for this developer tool only — scoped to :host(.hs-theme-dark)
   rather than :root, so it never touches the main dashboard. Custom properties
   inherit into every nested child (ml-models/ml-labeling/help-*),
   which is why none of those files need their own dark-mode rules. */
:host(.hs-theme-dark) {
    --bg-primary: #1e1e1e;
    --bg-secondary: #2a2a2a;
    --bg-header: #14141f;
    --bg-hover: #333333;
    --bg-code: #151515;
    --border-color: #3a3a3a;
    --text-primary: #e8e8e8;
    --text-secondary: #aaaaaa;
    --accent-color: #4da3ff;
    --danger: #ff6b6b;
    --danger-color: #ff6b6b;
    --warning-bg: #4a3c00;
    --warning-border: #ffca28;
    --warning-fg: #ffd54f;
}

.ps-backdrop {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

.ps-panel {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    display: flex;
    flex-direction: column;
    background: var(--bg-primary, #fff);
    color: var(--text-primary, #333);
    z-index: 1001;
}

.ps-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background: var(--bg-header, #1a1a2e);
    color: #fff;
    min-height: 44px;
}

.ps-title {
    font-size: 16px;
    font-weight: 600;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.ps-status {
    font-size: 12px;
    opacity: 0.8;
}

.ps-body {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.ps-view {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
}

.ps-view.hidden {
    display: none;
}

/* Toolbar */
.ps-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
}

/* Pipeline table */
.ps-pipeline-table {
    flex: 1;
    overflow: auto;
    padding: 0 16px;
}

.ps-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.ps-table th,
.ps-table td {
    text-align: left;
    padding: 8px 12px;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
}

.ps-table th {
    font-weight: 600;
    color: var(--text-secondary, #666);
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.ps-table tr:hover {
    background: var(--bg-hover, #f5f5f5);
}

.ps-pipeline-link {
    color: var(--accent-color, #0066cc);
    text-decoration: none;
}

.ps-pipeline-link:hover {
    text-decoration: underline;
}

/* State badges */
.ps-state-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
}

.ps-state-badge.state-running { background: #d4edda; color: #155724; }
.ps-state-badge.state-stopped { background: #fff3cd; color: #856404; }
.ps-state-badge.state-error   { background: #f8d7da; color: #721c24; }
.ps-state-badge.state-creating { background: #d1ecf1; color: #0c5460; }
.ps-state-badge.state-incomplete { background: #f8d7da; color: #721c24; }

/* Why an incomplete pipeline could not restore — shown in the detail header so the
   operator does not have to read server logs to find out. */
.ps-detail-problems {
    margin: 0 12px 8px;
    padding: 8px 12px;
    border-left: 3px solid #721c24;
    background: #f8d7da;
    color: #721c24;
    font-size: 12px;
}
.ps-detail-problems .ps-detail-problem + .ps-detail-problem {
    margin-top: 4px;
}
.ps-detail-problems code {
    background: rgba(0, 0, 0, 0.06);
    padding: 1px 4px;
    border-radius: 3px;
}

/* Sandbox lifecycle badge — created from an older ELM version, ready for
   cleanup rather than editing. Independent of the running/stopped state badge. */
.ps-sandbox-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    margin-left: 4px;
}
.ps-sandbox-badge.superseded { background: #e2e3e5; color: #383d41; }
.ps-sandbox-badge.archived   { background: #e2e3e5; color: #383d41; }

.ps-feature-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    background: var(--bg-secondary, #eef);
    color: var(--text-secondary, #555);
    margin-left: 4px;
}

.ps-evidence-panel {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
}

/* Action buttons in table rows */
.ps-row-actions {
    display: flex;
    gap: 4px;
    align-items: center;
}

.ps-row-actions hs-toolbar-button,
.ps-detail-actions hs-toolbar-button {
    display: inline-flex;
    align-items: center;
}

.ps-row-actions .btn,
.ps-detail-actions .btn {
    padding: 2px 8px;
    font-size: 11px;
}

/* Detail view */
.ps-detail-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
}

.ps-detail-name {
    font-size: 15px;
    font-weight: 600;
}

.ps-detail-actions {
    display: flex;
    gap: 6px;
    margin-left: auto;
}

.ps-detail-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* Tabs */
.ps-detail-tabs {
    display: flex;
    gap: 0;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
    padding: 0 16px;
}

.ps-tab {
    padding: 8px 16px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 13px;
    color: var(--text-secondary, #666);
    border-bottom: 2px solid transparent;
}

.ps-tab.active {
    color: var(--text-primary, #333);
    border-bottom-color: var(--accent-color, #0066cc);
    font-weight: 600;
}

.ps-tab-panel {
    flex: 1;
    overflow: auto;
}

.ps-tab-panel.hidden {
    display: none;
}

/* Log output */
.ps-log-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 16px;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
    flex-shrink: 0;
}

.ps-log-filters {
    display: flex;
    gap: 8px;
    align-items: center;
}

.ps-filter-toggle {
    display: flex;
    align-items: center;
    gap: 3px;
    font-size: 11px;
    cursor: pointer;
}

.ps-filter-toggle input { margin: 0; }

.ps-log-count {
    margin-left: auto;
    font-size: 11px;
    color: var(--text-secondary, #666);
}

.ps-log-limit-label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: var(--text-secondary, #666);
}

.ps-log-limit { width: 62px; }

.ps-toggle-on {
    background: var(--accent-color, #0066cc);
    color: #fff;
}

.ps-log-test-bar {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 16px;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
    flex-shrink: 0;
    background: var(--bg-secondary, #f8f8f8);
}
.ps-log-test-bar select { max-width: 220px; }

.ps-log-output {
    flex: 1;
    overflow-y: auto;
    padding: 8px 16px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace;
    font-size: 12px;
    line-height: 1.5;
    background: var(--bg-code, #1e1e1e);
    color: #d4d4d4;
}

.ps-log-placeholder {
    color: #888;
    font-style: italic;
    padding: 20px;
    text-align: center;
}

.ps-log-line {
    white-space: pre-wrap;
    word-break: break-all;
}

.ps-log-line .log-ts    { color: #6a9955; }
.ps-log-line .log-level { font-weight: 600; }
.ps-log-line .log-msg   { white-space: pre-wrap; }
.ps-log-line .log-json-key  { color: #9cdcfe; }
.ps-log-line .log-json-str  { color: #ce9178; }
.ps-log-line .log-json-num  { color: #b5cea8; }
.ps-log-line .log-json-bool { color: #569cd6; }

.ps-level-error, .ps-log-line.level-error .log-level { color: #f44747; }
.ps-level-warn,  .ps-log-line.level-warn .log-level  { color: #cca700; }
.ps-level-info,  .ps-log-line.level-info .log-level   { color: #4fc1ff; }
.ps-level-debug, .ps-log-line.level-debug .log-level  { color: #888; }
.ps-level-verbose, .ps-log-line.level-verbose .log-level { color: #666; }

/* Config panel */
.ps-config-content {
    margin: 0;
    padding: 16px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace;
    font-size: 12px;
    line-height: 1.5;
    white-space: pre-wrap;
    overflow: auto;
}

/* Test panel */
.ps-test-panel {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.ps-test-cases-bar {
    display: flex;
    align-items: center;
    gap: 8px;
}
.ps-test-case-select {
    flex: 1;
    max-width: 300px;
}
.ps-test-desc {
    font-size: 12px;
    color: var(--text-secondary, #666);
    font-style: italic;
}

.ps-test-save-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: 8px;
}

.ps-test-editing-label {
    font-size: 12px;
    color: var(--text-secondary, #666);
}

.ps-test-action-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
}

.ps-test-label {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 4px;
}

.ps-test-textarea {
    width: 100%;
    min-height: 120px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace;
    font-size: 12px;
    padding: 8px;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 4px;
    resize: vertical;
    box-sizing: border-box;
}

.ps-test-output {
    border-top: 1px solid var(--border-color, #e0e0e0);
    padding-top: 12px;
}

.ps-test-result {
    margin: 0;
    padding: 12px;
    background: var(--bg-code, #1e1e1e);
    color: #d4d4d4;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace;
    font-size: 12px;
    line-height: 1.5;
    white-space: pre-wrap;
    border-radius: 4px;
    max-height: 300px;
    overflow: auto;
}

/* Stats panel */
.ps-stats-panel { padding: 16px; overflow: auto; }
.ps-stats-toolbar { display: flex; justify-content: flex-end; margin-bottom: 12px; }
.ps-stats-placeholder { color: #888; font-size: 13px; padding: 24px 0; text-align: center; }
.ps-stats-section { margin-bottom: 20px; }
.ps-stats-title { font-size: 12px; font-weight: 600; text-transform: uppercase; color: #666; margin-bottom: 8px; }
.ps-stats-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 10px; }
.ps-stat-card { background: var(--bg-code, #f5f5f5); border-radius: 6px; padding: 12px; text-align: center; }
.ps-stat-value { font-size: 18px; font-weight: 600; margin-bottom: 4px; }
.ps-stat-label { font-size: 11px; color: #888; }
.ps-stats-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.ps-stats-table th, .ps-stats-table td { padding: 6px 10px; text-align: left; border-bottom: 1px solid var(--border-color, #e0e0e0); }
.ps-stats-table th { font-weight: 600; font-size: 11px; text-transform: uppercase; color: #666; }

/* Form view */
.ps-form-body {
    padding: 16px;
    max-width: 640px;
    overflow: auto;
}

.ps-form-group {
    margin-bottom: 16px;
}

.ps-form-group > label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 4px;
}

.ps-form-hint {
    display: block;
    font-size: 11px;
    color: var(--text-secondary, #888);
    margin-top: 2px;
}

.ps-input {
    width: 100%;
    padding: 6px 8px;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 4px;
    font-size: 13px;
    box-sizing: border-box;
    color: inherit;
    background: var(--bg-primary, #fff);
}

.ps-input-sm {
    width: 80px;
}

.ps-topic-row {
    display: flex;
    gap: 6px;
    align-items: center;
}
.ps-topic-row .ps-input {
    flex: 1;
}

.ps-radio-group {
    display: flex;
    gap: 16px;
    font-size: 13px;
}

.ps-pipeline-steps {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 8px;
}

.ps-step-row {
    display: flex;
    align-items: center;
    gap: 6px;
}

.ps-step-row .ps-input {
    flex: 1;
}

.ps-step-row .btn-icon {
    flex-shrink: 0;
}

.ps-form-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 13px;
}

.ps-form-advanced.hidden {
    display: none;
}

.ps-form-actions {
    display: flex;
    gap: 8px;
    margin-top: 16px;
}

.ps-form-result {
    margin-top: 12px;
    padding: 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: pre-wrap;
}

.ps-form-result.hidden { display: none; }
.ps-form-result.valid   { background: #d4edda; color: #155724; }
.ps-form-result.invalid { background: #f8d7da; color: #721c24; }

/* Plugin manager */
.ps-plugin-toolbar {
    padding: 10px 16px;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
}

.ps-upload-zone {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px;
    border: 2px dashed var(--border-color, #ccc);
    border-radius: 6px;
    font-size: 13px;
    color: var(--text-secondary, #666);
    text-align: center;
    justify-content: center;
    transition: border-color 0.15s, background 0.15s;
}

.ps-upload-zone.drag-over {
    border-color: var(--accent-color, #0066cc);
    background: rgba(0, 102, 204, 0.05);
}

/* Topic subscriptions — neutral presentation, not a warning/error state */
.ps-subscriptions-section {
    border-bottom: 1px solid var(--border-color, #e0e0e0);
}

.ps-subscriptions-summary {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background: none;
    border: none;
    font-size: 13px;
    color: var(--text-secondary, #666);
    cursor: pointer;
    text-align: left;
}

.ps-subscriptions-caret {
    transition: transform 0.15s;
}

.ps-subscriptions-summary.expanded .ps-subscriptions-caret {
    transform: rotate(180deg);
}

.ps-subscriptions-detail {
    padding: 0 16px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.ps-subscriptions-list {
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 160px;
    overflow-y: auto;
    font-size: 12px;
    font-family: monospace;
    color: var(--text-secondary, #666);
}

.ps-subscriptions-list li {
    padding: 2px 0;
}

.ps-plugin-list {
    flex: 1;
    overflow: auto;
    padding: 0 16px;
}

.ps-plugin-card {
    padding: 10px 0;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.ps-plugin-name {
    font-weight: 600;
    font-size: 13px;
}

.ps-plugin-exports {
    font-size: 11px;
    color: var(--text-secondary, #666);
    margin-top: 2px;
}

.ps-plugin-info {
    flex: 1;
    min-width: 0;
}

.ps-plugin-desc {
    font-size: 11px;
    color: var(--text-secondary, #666);
    margin-top: 3px;
    line-height: 1.4;
}

.ps-fn-list {
    margin-top: 6px;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.ps-fn-row {
    font-size: 11px;
    display: flex;
    align-items: baseline;
    gap: 5px;
    flex-wrap: wrap;
}

.ps-fn-name {
    font-weight: 600;
    color: var(--text-primary, #333);
    flex-shrink: 0;
}

.ps-fn-badge {
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    background: var(--bg-secondary, #f0f0f0);
    color: var(--text-secondary, #777);
    border-radius: 3px;
    padding: 1px 4px;
    flex-shrink: 0;
}

.ps-fn-desc {
    color: var(--text-secondary, #888);
    font-style: italic;
}

.ps-plugin-actions {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
}

/* Empty state */
.ps-empty-state {
    padding: 40px 16px;
    text-align: center;
    color: var(--text-secondary, #888);
    font-size: 13px;
}

/* Shared button styles */
.btn {
    padding: 6px 12px;
    border: 1px solid var(--border-color, #ccc);
    border-radius: 4px;
    background: var(--bg-primary, #fff);
    color: var(--text-primary, #333);
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;
}

.btn:hover { background: var(--bg-hover, #f0f0f0); }
.btn:active { transform: scale(0.96); filter: brightness(0.92); }
.btn:disabled { opacity: 0.5; cursor: default; }

.btn-primary {
    background: var(--accent-color, #0066cc);
    color: #fff;
    border-color: var(--accent-color, #0066cc);
}

.btn-primary:hover { background: #005bb5; }
.btn-primary:active { background: #004a99; }

.btn-secondary {
    background: var(--bg-secondary, #f5f5f5);
}

.btn-danger {
    color: #d32f2f;
    border-color: #d32f2f;
}

.btn-danger:hover { background: #fbe9e7; }
.btn-danger:active { background: #f5d0cc; }

.btn-sm {
    padding: 3px 8px;
    font-size: 11px;
}

.btn-icon {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    padding: 4px;
    color: inherit;
}
.btn-icon:active { transform: scale(0.85); }

.ps-loading-overlay {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 500;
}
.ps-loading-overlay.hidden { display: none; }
.ps-spinner {
    width: 28px;
    height: 28px;
    border: 3px solid #e0e0e0;
    border-top-color: var(--accent-color, #0066cc);
    border-radius: 50%;
    animation: ps-spin 0.7s linear infinite;
}
@keyframes ps-spin { to { transform: rotate(360deg); } }

.link-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: var(--accent-color, #0066cc);
    font-size: 12px;
    padding: 0;
    text-decoration: underline;
}

.hidden {
    display: none !important;
}

/* Confirm dialog overlay */
.ps-confirm-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1100;
}

.ps-confirm-dialog {
    background: var(--bg-primary, #fff);
    border-radius: 8px;
    padding: 20px;
    max-width: 360px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
}

.ps-confirm-dialog p {
    margin: 0 0 16px;
    font-size: 13px;
}

.ps-confirm-dialog .ps-confirm-actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}

#ps-prompt-input {
    width: 100%;
    margin-bottom: 12px;
    box-sizing: border-box;
}

.ps-alert-dialog {
    max-width: 600px;
}
.ps-alert-content {
    margin: 0 0 16px;
    font-size: 13px;
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 60vh;
    overflow: auto;
}

.ps-builder-main {
    flex: 1;
    overflow-y: auto;
}

.ps-scratch-notice {
    font-size: 12px;
    color: var(--text-secondary, #666);
    background: var(--bg-secondary, #f5f5f5);
    border-left: 3px solid var(--accent-color, #0066cc);
    padding: 8px 12px;
    margin-bottom: 16px;
}
.ps-scratch-notice code {
    background: #eef;
    padding: 1px 6px;
    border-radius: 3px;
}

.ps-add-step-row {
    display: flex;
    gap: 6px;
    margin-bottom: 8px;
}
.ps-add-step-row select {
    flex: 1;
}

.ps-step-ref {
    flex: 1;
    font-family: 'SF Mono', 'Menlo', 'Monaco', monospace;
    font-size: 12px;
    color: var(--text-primary, #333);
    padding: 4px 8px;
    background: var(--bg-secondary, #f5f5f5);
    border-radius: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}

.ps-step-tap {
    display: none;
}

/* Configure button — tuning mode only (see sandbox-refocus-view-tune.md § 4.1) */
.ps-step-configure {
    font-size: 10px;
    flex-shrink: 0;
}

/* Step config popover */
.ps-step-popover {
    position: fixed;
    z-index: 1100;
    background: var(--bg-primary, #fff);
    border: 1px solid var(--border-color, #ccc);
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.12);
    padding: 12px;
    min-width: 280px;
}

.ps-popover-content .ps-form-row {
    margin-bottom: 6px;
}

.ps-popover-content .ps-form-row label {
    min-width: 80px;
    font-size: 11px;
}

.ps-form-row-label {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-secondary, #666);
    margin: 8px 0 2px;
}

.ps-opts-textarea {
    width: 100%;
    min-height: 60px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', monospace;
    font-size: 11px;
    resize: vertical;
    box-sizing: border-box;
}

.ps-popover-actions {
    display: flex;
    gap: 6px;
    justify-content: flex-end;
    margin-top: 8px;
}

/* Plugin category header */
.ps-plugin-category-header {
    padding: 8px 0 4px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--text-secondary, #888);
    border-bottom: 1px solid var(--border-color, #eee);
}

.ps-plugin-label {
    font-size: 11px;
    color: var(--text-secondary, #888);
}

/* Configurable plugin config panel */
.ps-cfg-panel {
    border: 1px solid var(--border-color, #ddd);
    border-radius: 6px;
    margin: 4px 0 8px;
    background: var(--bg-primary, #fafafa);
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.ps-cfg-modal {
    background: var(--bg-primary, #fff);
    border-radius: 8px;
    width: 90%;
    max-width: 600px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
}
.ps-cfg-modal .ps-cfg-body {
    overflow-y: auto;
    flex: 1;
}

.ps-cfg-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border-bottom: 1px solid var(--border-color, #eee);
    font-size: 12px;
}

.ps-cfg-body { padding: 8px 12px; }

/* Widen ps-input-sm inputs inside the config modal so placeholders aren't truncated.
   Keeps numeric inputs compact. */
.ps-cfg-modal .ps-input-sm { width: 100%; box-sizing: border-box; }
.ps-cfg-modal input[type="number"].ps-input-sm { width: 100px; }

/* Field-picker cell fills its slot in kv rows / list items / filter rules. */
.ps-field-picker-cell { flex: 1; min-width: 0; }
.ps-cfg-filter-rule .ps-field-picker-cell { flex: 2; min-width: 80px; }
.ps-cfg-filter-rule .ps-cfg-rule-vfield-wrap { flex: 2; min-width: 60px; display: flex; }
.ps-cfg-filter-rule .ps-cfg-rule-vfield-wrap.hidden { display: none; }

.ps-cfg-footer {
    display: flex;
    gap: 6px;
    justify-content: flex-end;
    padding: 8px 12px;
    border-top: 1px solid var(--border-color, #eee);
}

.ps-cfg-section {
    margin-bottom: 10px;
}

.ps-cfg-section > label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 4px;
    color: var(--text-secondary, #555);
}

.ps-cfg-toggles {
    display: flex;
    gap: 16px;
}

.ps-cfg-toggles label {
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
}

/* Key-value rows (rename, match) */
.ps-cfg-kv-row, .ps-cfg-set-row {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 3px;
}

.ps-cfg-kv-row span, .ps-cfg-set-row span {
    font-size: 11px;
    color: var(--text-secondary, #999);
    flex-shrink: 0;
}

.ps-cfg-kv-row input, .ps-cfg-set-row input[type="text"] {
    flex: 1;
    min-width: 60px;
}

.ps-cfg-set-row label {
    font-size: 10px;
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
    color: var(--text-secondary, #888);
}

.ps-cfg-list-item {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 3px;
}

.ps-cfg-list-item input { flex: 1; }

.ps-cfg-row-remove {
    font-size: 12px;
    opacity: 0.5;
    cursor: pointer;
    flex-shrink: 0;
}

.ps-cfg-row-remove:hover { opacity: 1; }

/* Enrich source label + required marker */
.ps-cfg-source-label {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: var(--bg-secondary, #f0f0f0);
    cursor: default;
}
.ps-cfg-source-label em { color: var(--text-secondary, #999); }
.ps-cfg-required { color: var(--danger, #c00); }

/* Enrich match pairs */
.ps-cfg-match-pair {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
}
.ps-cfg-match-pair span { font-size: 11px; color: var(--text-secondary, #999); flex-shrink: 0; }
.ps-cfg-match-pair select { flex: 1; min-width: 80px; }
.ps-cfg-match-pair .ps-cfg-match-right {
    flex: 1; min-width: 80px;
    background: var(--bg-secondary, #f0f0f0); color: var(--text-secondary, #666);
    cursor: not-allowed;
}

/* Enrich fields grid */
.ps-cfg-field-controls { margin-bottom: 6px; }
.ps-cfg-select-all-label { font-size: 11px; display: flex; align-items: center; gap: 4px; font-weight: 600; }
.ps-cfg-field-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 2px 12px;
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid var(--border-color, #eee);
    border-radius: 4px;
    padding: 6px 8px;
}
.ps-cfg-field-cb { font-size: 12px; display: flex; align-items: center; gap: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ps-cfg-field-cb input { flex-shrink: 0; }

/* Shared per-field join projection list (enrich + flatMap): Merge as / On miss /
   Default / If present per selected field, plus a trailing remove-button column. */
.ps-cfg-projection-header,
.ps-cfg-projection-row {
    display: grid;
    grid-template-columns: minmax(70px, 1fr) minmax(70px, 1fr) 90px minmax(80px, 1fr) 90px 20px;
    gap: 6px;
    align-items: center;
}
.ps-cfg-projection-header {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: var(--text-secondary, #999);
    margin-bottom: 4px;
}
.ps-cfg-projection-row { margin-bottom: 4px; }
.ps-cfg-projection-source {
    font-size: 12px;
    color: var(--text-secondary, #666);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.ps-cfg-projection-remove { font-size: 12px; padding: 0; }
.ps-cfg-join-add-manual { margin-top: 4px; }

.ps-cfg-join-defaults-row {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}
.ps-cfg-join-defaults-row label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
}

/* Filter rule rows */
.ps-cfg-filter-rule {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
    flex-wrap: wrap;
}

.ps-cfg-rule-field { flex: 2; min-width: 80px; }
.ps-cfg-rule-op { flex: 0 0 auto; min-width: 70px; }
.ps-cfg-rule-value { flex: 2; min-width: 60px; }
.ps-cfg-rule-vfield { flex: 2; min-width: 60px; }

.ps-cfg-rule-dyn {
    font-size: 10px;
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
    color: var(--text-secondary, #888);
}

.ps-cfg-rule-invert {
    font-size: 10px;
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
    color: var(--text-secondary, #888);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.ps-cfg-rule-invert:has(input:checked) {
    color: var(--danger, #c00);
    font-weight: 600;
}

/* Window form extras */
.ps-cfg-dur-row {
    display: flex;
    gap: 6px;
    align-items: center;
}

.ps-cfg-dur-row input { width: 80px; }
.ps-cfg-dur-row select { width: 100px; }

.ps-cfg-kv-inline {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
}

.ps-cfg-kv-inline label {
    font-size: 11px;
    min-width: 60px;
    color: var(--text-secondary, #666);
}

.ps-cfg-kv-inline input { flex: 1; }

/* -- Warning / hint callouts -- */
.ps-cfg-warning {
    display: block;
    padding: 6px 10px;
    margin-top: 6px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 1.4;
    background: var(--warning-bg, #fff3cd);
    color: var(--warning-fg, #856404);
    border: 1px solid var(--warning-border, #ffc107);
}

.ps-cfg-warning code {
    background: rgba(0,0,0,.06);
    padding: 1px 4px;
    border-radius: 3px;
    font-size: 11px;
}

.ps-cfg-perf-guide .ps-form-hint {
    line-height: 1.7;
}

.ps-cfg-compact-section {
    border-top: 1px solid var(--border-color, #e0e0e0);
    margin-top: 8px;
    padding-top: 8px;
}

.ps-cfg-db-warning,
.ps-cfg-scan-warning {
    margin-top: 4px;
}

/* ---- Namespace selector (header) ---- */
.ps-namespace-selector {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: rgba(255,255,255,0.85);
}
.ps-namespace-label {
    text-transform: uppercase;
    letter-spacing: 0.5px;
    opacity: 0.7;
}
.ps-namespace-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: rgba(255,255,255,0.1);
    color: #fff;
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    font-family: monospace;
    min-width: 120px;
    justify-content: space-between;
}
.ps-namespace-btn:hover {
    background: rgba(255,255,255,0.18);
}
.ps-namespace-caret {
    font-size: 10px;
    opacity: 0.7;
}
.ps-ns-popover {
    position: fixed;
    background: var(--bg-primary, #fff);
    color: var(--text-primary, #333);
    border: 1px solid var(--border-color, #ccc);
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.18);
    padding: 10px;
    z-index: 1200;
    min-width: 260px;
    max-width: 360px;
    font-size: 12px;
}
.ps-ns-popover-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--text-secondary, #666);
    margin-bottom: 6px;
}
.ps-ns-popover-input {
    width: 100%;
    box-sizing: border-box;
    font-family: monospace;
    margin-bottom: 8px;
}
.ps-ns-popover-list {
    max-height: 240px;
    overflow-y: auto;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 4px;
    margin-bottom: 8px;
}
.ps-ns-popover-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    cursor: pointer;
    font-family: monospace;
}
.ps-ns-popover-item:hover { background: var(--bg-hover, #f5f5f5); }
.ps-ns-popover-item.selected { background: var(--accent-color, #0066cc); color: #fff; }
.ps-ns-popover-item-badge {
    margin-left: auto;
    font-family: sans-serif;
    font-size: 10px;
    padding: 1px 6px;
    border-radius: 8px;
    background: var(--bg-hover, #eee);
    color: var(--text-secondary, #666);
}
.ps-ns-popover-item.selected .ps-ns-popover-item-badge {
    background: rgba(255,255,255,0.2);
    color: #fff;
}
.ps-ns-popover-actions {
    display: flex;
    gap: 6px;
    justify-content: flex-end;
}
.ps-ns-popover-hint {
    font-size: 11px;
    color: var(--text-secondary, #666);
    margin-bottom: 6px;
}

/* Small pill in view headers showing current namespace */
.ps-ns-badge {
    display: inline-block;
    padding: 2px 8px;
    background: var(--bg-hover, #eef);
    color: var(--text-secondary, #446);
    border-radius: 10px;
    font-family: monospace;
    font-size: 11px;
    margin-left: 8px;
}
.ps-ns-badge:empty { display: none; }

/* ---- Schema Explorer (v2) ---- */
.ps-schema-explorer-layout {
    flex: 1;
    display: grid;
    grid-template-columns: 220px 320px 1fr;
    gap: 0;
    overflow: hidden;
    min-height: 0;
}

.ps-schema-explorer-col {
    border-right: 1px solid var(--border-color, #e0e0e0);
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}
.ps-schema-explorer-col:last-child { border-right: none; }

.ps-schema-explorer-col-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--text-secondary, #666);
    border-bottom: 1px solid var(--border-color, #e0e0e0);
    gap: 8px;
}
.ps-schema-explorer-col-header .ps-input {
    text-transform: none;
    letter-spacing: 0;
    font-weight: 400;
}

.ps-schema-explorer-list {
    flex: 1;
    overflow-y: auto;
    padding: 4px 0;
}

.ps-schema-explorer-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 13px;
    border-left: 3px solid transparent;
}
.ps-schema-explorer-item:hover { background: var(--bg-hover, #f5f5f5); }
.ps-schema-explorer-item.selected {
    background: var(--bg-hover, #eaf1fb);
    border-left-color: var(--accent-color, #0066cc);
}
.ps-schema-explorer-item-name { font-family: monospace; }
.ps-schema-explorer-item-meta {
    margin-left: auto;
    font-size: 10px;
    color: var(--text-secondary, #666);
}

.ps-schema-explorer-item-badges {
    display: inline-flex;
    gap: 4px;
    margin-left: auto;
}
.ps-schema-explorer-badge {
    font-size: 10px;
    padding: 1px 6px;
    border-radius: 8px;
    background: #eee;
    color: #555;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}
.ps-schema-explorer-badge-prod {
    background: #e2f0ff;
    color: #0055aa;
}
.ps-schema-explorer-badge-overlay {
    background: #fff2cc;
    color: #7a5b00;
}
.ps-schema-explorer-badge-sandbox {
    background: #e6f4ea;
    color: #1b6b2f;
}

.ps-schema-explorer-common {
    padding: 8px 12px;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
    background: var(--bg-hover, #fafafa);
}
.ps-schema-explorer-common-title {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--text-secondary, #666);
    margin-bottom: 4px;
}
.ps-schema-explorer-common-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}
.ps-schema-explorer-common-chip {
    font-family: monospace;
    font-size: 11px;
    padding: 1px 6px;
    background: #eef;
    color: #337;
    border-radius: 3px;
    cursor: help;
}

.ps-schema-explorer-detail-body {
    flex: 1;
    overflow-y: auto;
    padding: 12px 16px;
}
.ps-schema-explorer-detail-header {
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-bottom: 4px;
}
.ps-schema-explorer-detail-name {
    font-family: monospace;
    font-size: 16px;
    font-weight: 600;
}
.ps-schema-explorer-detail-version {
    font-size: 12px;
    color: var(--text-secondary, #666);
}
.ps-schema-explorer-detail-desc {
    font-size: 12px;
    color: var(--text-secondary, #666);
    margin-bottom: 12px;
}
.ps-schema-explorer-detail-section {
    margin-top: 14px;
}
.ps-schema-explorer-detail-section-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--text-secondary, #666);
    margin-bottom: 6px;
}
.ps-schema-explorer-prop-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
}
.ps-schema-explorer-prop-table th,
.ps-schema-explorer-prop-table td {
    text-align: left;
    padding: 4px 8px;
    border-bottom: 1px solid var(--border-color, #eee);
    vertical-align: top;
}
.ps-schema-explorer-prop-table th {
    font-weight: 600;
    color: var(--text-secondary, #666);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 10px;
}
.ps-schema-explorer-prop-name { font-family: monospace; }
.ps-schema-explorer-prop-type {
    font-family: monospace;
    color: #06c;
}
.ps-schema-explorer-storage {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    font-size: 11px;
}
.ps-schema-explorer-storage-item {
    padding: 2px 8px;
    background: var(--bg-hover, #f5f5f5);
    border-radius: 4px;
    font-family: monospace;
}
.ps-schema-explorer-raw {
    background: #1a1a2e;
    color: #eee;
    padding: 10px;
    border-radius: 4px;
    font-size: 11px;
    max-height: 260px;
    overflow: auto;
    white-space: pre;
    font-family: monospace;
}

/* ---- Schema Explorer editor + actions (step 2) ---- */
.ps-schema-explorer-col-actions {
    display: flex;
    align-items: center;
    gap: 4px;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 400;
}
.ps-schema-explorer-filter-row {
    padding: 6px 12px;
    border-bottom: 1px solid var(--border-color, #eee);
}
.ps-schema-explorer-filter-row .ps-input { width: 100%; box-sizing: border-box; }

.ps-schema-editor-toolbar {
    margin-bottom: 8px;
    display: flex;
    gap: 6px;
    align-items: center;
    flex-wrap: wrap;
}
.ps-schema-editor-common-note {
    font-size: 11px;
    color: var(--text-secondary, #666);
    background: #fafafa;
    padding: 6px 8px;
    border-radius: 4px;
    margin-bottom: 10px;
}
.ps-schema-editor-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 8px;
    margin-bottom: 10px;
}
.ps-schema-editor-field { margin-bottom: 10px; }
.ps-schema-editor-field > label {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--text-secondary, #666);
    margin-bottom: 4px;
}
.ps-schema-editor-label {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--text-secondary, #666);
    margin: 6px 0 4px;
}
.ps-schema-editor-storage-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}
.ps-schema-editor-storage-row > label {
    margin-bottom: 0;
    margin-right: 6px;
}
.ps-schema-editor-inline {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    text-transform: none;
    letter-spacing: 0;
    color: inherit;
}
.ps-schema-editor-props-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}
.ps-schema-editor-quickadd {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
}
.ps-schema-editor-props {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.ps-schema-editor-prop-row {
    display: grid;
    grid-template-columns: minmax(120px, 1.4fr) 100px 100px 1fr 1fr auto;
    gap: 4px;
    align-items: center;
}
.ps-schema-editor-prop-remove {
    background: transparent;
    border: 1px solid transparent;
    color: var(--text-secondary, #888);
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
}
.ps-schema-editor-prop-remove:hover {
    background: #ffecec;
    color: #a00;
    border-color: #f5c6c6;
}
.ps-schema-editor-raw {
    width: 100%;
    min-height: 320px;
    font-family: monospace;
    font-size: 12px;
    padding: 8px;
    box-sizing: border-box;
    border: 1px solid var(--border-color, #ccc);
    border-radius: 4px;
    resize: vertical;
}

/* Copy-to-clipboard modal */
.ps-copy-path {
    font-size: 12px;
    margin-bottom: 8px;
    color: var(--text-secondary, #555);
}
.ps-copy-path code {
    background: #eef;
    padding: 1px 6px;
    border-radius: 3px;
    font-size: 11px;
}
.ps-copy-content {
    background: #1a1a2e;
    color: #eee;
    font-family: monospace;
    font-size: 12px;
    padding: 10px;
    border-radius: 4px;
}

/* ---- Outputs editor (builder form, step 3) ---- */
.ps-form-outputs {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 6px;
}
.ps-form-output-row {
    display: grid;
    grid-template-columns: 1.4fr 1.4fr auto auto auto;
    gap: 6px;
    align-items: center;
}
.ps-output-remove {
    background: transparent;
    border: 1px solid transparent;
    color: var(--text-secondary, #888);
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 4px;
}
.ps-output-remove:hover { background: #ffecec; color: #a00; }

/* ---- Orphan cleanup (step 4) ---- */
.ps-orphan-count {
    display: inline-block;
    background: var(--danger-color, #cc3333);
    color: #fff;
    font-size: 10px;
    padding: 1px 6px;
    border-radius: 8px;
    margin-left: 4px;
}
.ps-orphan-list {
    max-height: 320px;
    overflow-y: auto;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 4px;
    margin: 12px 0;
}
.ps-orphan-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 12px;
    border-bottom: 1px solid var(--border-color, #eee);
}
.ps-orphan-row:last-child { border-bottom: none; }
.ps-orphan-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.ps-orphan-ns {
    font-family: monospace;
    font-size: 13px;
}
.ps-orphan-count-inline {
    font-size: 11px;
    color: var(--text-secondary, #666);
}
.ps-orphan-actions {
    display: flex;
    gap: 8px;
    align-items: center;
}

/* ---- Telemetry drawer (step 5) ---- */
.ps-logs-layout {
    flex: 1;
    display: flex;
    min-height: 0;
    overflow: hidden;
}
.ps-logs-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
}
.ps-telemetry-drawer {
    width: 420px;
    border-left: 1px solid var(--border-color, #e0e0e0);
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    background: var(--bg-secondary, #fafafa);
    overflow: hidden;
    transition: width 0.15s ease;
}
.ps-telemetry-drawer.collapsed {
    width: 0;
    border-left: none;
}
.ps-telemetry-drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 10px;
    border-bottom: 1px solid var(--border-color, #eee);
    background: var(--bg-primary, #fff);
}
.ps-telemetry-mode-toggle {
    display: inline-flex;
    gap: 4px;
}
.ps-tel-mode-btn {
    background: transparent;
    border: 1px solid var(--border-color, #ccc);
    padding: 2px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
}
.ps-tel-mode-btn.active {
    background: var(--accent-color, #0066cc);
    color: #fff;
    border-color: var(--accent-color, #0066cc);
}
.ps-telemetry-drawer-body {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.ps-tel-filters {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.ps-tel-filter-row {
    display: grid;
    grid-template-columns: 90px 1fr;
    gap: 6px;
    align-items: center;
}
.ps-tel-filter-row-full {
    grid-template-columns: 90px 1fr 1fr;
}
.ps-tel-filter-row label {
    font-size: 11px;
    color: var(--text-secondary, #666);
    text-transform: uppercase;
    letter-spacing: 0.4px;
}
.ps-tel-range-chips {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
    margin-top: 4px;
}
.ps-tel-chip {
    font-size: 11px;
    padding: 2px 8px;
}
.ps-tel-chip.active {
    background: var(--accent-color, #0066cc);
    color: #fff;
}
.ps-tel-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    padding-top: 4px;
    border-top: 1px solid var(--border-color, #eee);
}
.ps-tel-count {
    font-size: 11px;
    color: var(--text-secondary, #666);
    margin-left: auto;
}
.ps-tel-rows {
    flex: 1;
    overflow-y: auto;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 4px;
    background: var(--bg-primary, #fff);
}
.ps-tel-row {
    border-bottom: 1px solid var(--border-color, #eee);
}
.ps-tel-row-head {
    display: grid;
    grid-template-columns: 16px 1fr 1fr auto;
    gap: 6px;
    align-items: center;
    padding: 4px 8px;
    cursor: pointer;
    font-size: 12px;
    font-family: monospace;
}
.ps-tel-row-head:hover { background: var(--bg-hover, #f5f5f5); }
.ps-tel-row-dom { color: var(--text-secondary, #666); }
.ps-tel-row-mt { color: var(--accent-color, #06c); }
.ps-tel-row-ts {
    font-size: 11px;
    color: var(--text-secondary, #888);
    text-align: right;
}
.ps-tel-row-payload {
    background: #1a1a2e;
    color: #eee;
    margin: 0;
    padding: 8px 12px;
    font-size: 11px;
    max-height: 200px;
    overflow: auto;
    white-space: pre;
}

/* ---- Topology view (step 6) ---- */
.ps-topology-body {
    flex: 1;
    overflow: auto;
    background: repeating-linear-gradient(
        0deg, #fafafa, #fafafa 24px,
        #f0f0f0 24px, #f0f0f0 25px
    );
}
.ps-topology-canvas {
    min-height: 100%;
    padding: 12px;
}
.ps-topo-svg {
    display: block;
    max-width: none;
}
.ps-topo-node { cursor: pointer; }
.ps-topo-node-rect {
    fill: #fff;
    stroke: var(--border-color, #ccc);
    stroke-width: 1;
}
.ps-topo-node:hover .ps-topo-node-rect { stroke: var(--accent-color, #06c); }
.ps-topo-node-title {
    font-family: monospace;
    font-size: 12px;
    fill: var(--text-primary, #333);
    font-weight: 600;
}
.ps-topo-node-sub {
    font-size: 10px;
    fill: var(--text-secondary, #666);
}
.ps-topo-node-badge {
    font-size: 9px;
    fill: #a44;
    text-transform: uppercase;
}
.ps-topo-edge { cursor: pointer; }
.ps-topo-edge:hover path { stroke-width: 3; }
.ps-topo-edge-label {
    font-size: 9px;
    fill: var(--text-secondary, #666);
    font-family: monospace;
    pointer-events: none;
}

/* Channel inspector */
.ps-channel-snapshot {
    margin: 8px 0;
    font-size: 12px;
}
.ps-channel-tail-controls {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 8px 0;
    padding: 8px 0;
    border-top: 1px solid var(--border-color, #eee);
    border-bottom: 1px solid var(--border-color, #eee);
}
.ps-channel-tail-body {
    max-height: 340px;
    overflow-y: auto;
    border: 1px solid var(--border-color, #eee);
    border-radius: 4px;
    background: var(--bg-primary, #fff);
    margin-bottom: 8px;
}

/* ---- Prepare PR view (step 7) ---- */
.ps-prepare-pr-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
}
.ps-pr-intro {
    font-size: 13px;
    margin-bottom: 16px;
    color: var(--text-secondary, #555);
}
.ps-pr-intro code {
    background: #eef;
    padding: 1px 6px;
    border-radius: 3px;
    font-size: 12px;
}
.ps-pr-section {
    margin-bottom: 24px;
}
.ps-pr-section-title {
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: var(--text-secondary, #666);
    margin: 0 0 8px;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--border-color, #eee);
}
.ps-pr-card {
    border: 1px solid var(--border-color, #ddd);
    border-radius: 6px;
    padding: 10px 12px;
    margin-bottom: 10px;
    background: var(--bg-primary, #fff);
}
.ps-pr-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 6px;
    flex-wrap: wrap;
}
.ps-pr-card-title {
    font-family: monospace;
    font-weight: 600;
    font-size: 13px;
}
.ps-pr-card-target {
    font-size: 11px;
    color: var(--text-secondary, #666);
}
.ps-pr-card-target code {
    background: #eef;
    padding: 1px 6px;
    border-radius: 3px;
    font-size: 11px;
}
.ps-pr-copy-btn { margin-left: auto; }
.ps-pr-preview {
    background: #1a1a2e;
    color: #eee;
    padding: 8px 12px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 11px;
    max-height: 240px;
    overflow: auto;
    white-space: pre;
    margin: 0;
}
.ps-pr-plugin-list {
    margin: 0 0 8px;
    padding-left: 20px;
    font-size: 12px;
}
.ps-pr-plugin-list code {
    background: #eef;
    padding: 1px 6px;
    border-radius: 3px;
}

/* ---- Feature Bundle view (import/export) ---- */
.ps-bundle-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.ps-bundle-tabs {
    display: flex;
    gap: 0;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
    padding: 0 16px;
}
.ps-bundle-tab {
    padding: 8px 16px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 13px;
    color: var(--text-secondary, #666);
    border-bottom: 2px solid transparent;
}
.ps-bundle-tab.active {
    color: var(--text-primary, #333);
    border-bottom-color: var(--accent-color, #0066cc);
    font-weight: 600;
}
.ps-bundle-tab-panel {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
}
.ps-bundle-import-intro {
    font-size: 13px;
    color: var(--text-secondary, #555);
    margin-bottom: 12px;
}
.ps-bundle-import-intro code {
    background: #eef;
    padding: 1px 6px;
    border-radius: 3px;
    font-size: 12px;
}
.ps-bundle-drop-zone {
    border: 2px dashed var(--border-color, #ccc);
    border-radius: 6px;
    transition: border-color 0.15s;
}
.ps-bundle-drop-zone.drag-over {
    border-color: var(--accent-color, #0066cc);
}
.ps-bundle-textarea {
    width: 100%;
    min-height: 160px;
    resize: vertical;
    font-family: monospace;
    font-size: 12px;
    box-sizing: border-box;
    border: none;
}
.ps-bundle-import-row, .ps-bundle-export-controls {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 12px 0;
    flex-wrap: wrap;
}
.ps-bundle-import-row label, .ps-bundle-export-controls label {
    font-size: 12px;
    color: var(--text-secondary, #666);
}
.ps-bundle-import-actions, .ps-bundle-export-actions {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
}
.ps-bundle-banner {
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 13px;
    margin-bottom: 12px;
}
.ps-bundle-banner-ok {
    background: #d4edda;
    color: #155724;
}
.ps-bundle-banner-error {
    background: #f8d7da;
    color: #721c24;
}
.ps-bundle-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    font-size: 12px;
    color: var(--text-secondary, #666);
    margin-bottom: 12px;
}
.ps-bundle-meta code {
    background: #eef;
    padding: 1px 6px;
    border-radius: 3px;
}
.ps-bundle-disposition-chip {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    padding: 1px 8px;
    border-radius: 10px;
    margin-left: auto;
}
.ps-bundle-disposition-applied {
    background: #d4edda;
    color: #155724;
}
.ps-bundle-disposition-verified {
    background: #d1ecf1;
    color: #0c5460;
}
.ps-bundle-disposition-carried {
    background: #e2e3e5;
    color: #41464b;
}
.ps-bundle-disposition-none {
    background: #fff3cd;
    color: #664d03;
}
.ps-bundle-section {
    margin-bottom: 16px;
}
.ps-bundle-section-title {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: var(--text-secondary, #666);
    margin: 0 0 6px;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--border-color, #eee);
}
.ps-bundle-rows {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.ps-bundle-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    padding: 6px 8px;
    border-radius: 4px;
    background: var(--bg-primary, #fff);
    border: 1px solid var(--border-color, #eee);
    font-size: 12px;
}
.ps-bundle-row code {
    background: #eef;
    padding: 1px 6px;
    border-radius: 3px;
}
.ps-bundle-row-warn {
    border-color: #ffe08a;
    background: #fffaf0;
}
.ps-bundle-row-error {
    border-color: #f5c2c7;
    background: #fdf2f3;
}
.ps-bundle-row-type {
    text-transform: uppercase;
    font-size: 10px;
    color: var(--text-secondary, #888);
}
.ps-bundle-row-code {
    font-family: monospace;
    color: #a94442;
}
.ps-bundle-row-reason {
    flex-basis: 100%;
    color: var(--text-secondary, #555);
}
.ps-bundle-error {
    color: #a94442;
    font-size: 13px;
    padding: 8px 0;
}
.ps-bundle-raw-row {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
}
.ps-bundle-raw-details summary {
    cursor: pointer;
    font-size: 12px;
    color: var(--text-secondary, #666);
    margin-bottom: 6px;
}
.ps-bundle-raw {
    background: #1a1a2e;
    color: #eee;
    padding: 8px 12px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 11px;
    max-height: 320px;
    overflow: auto;
    white-space: pre;
    margin: 0;
}
.ps-bundle-export-items {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 320px;
    overflow-y: auto;
    border: 1px solid var(--border-color, #eee);
    border-radius: 4px;
    padding: 6px;
    margin-bottom: 12px;
}
.ps-bundle-export-item-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    padding: 4px 6px;
}
.ps-bundle-export-item-row code {
    background: #eef;
    padding: 1px 6px;
    border-radius: 3px;
}
.ps-bundle-feature-chip {
    margin-left: auto;
    font-size: 11px;
    color: var(--text-secondary, #888);
    background: var(--bg-secondary, #f0f0f0);
    padding: 1px 8px;
    border-radius: 10px;
}

/* ---- Clone-with-downstream modal (step 8) ---- */
.ps-clone-downstream-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid var(--border-color, #eee);
    border-radius: 4px;
    padding: 6px;
}
.ps-clone-downstream-row {
    display: grid;
    grid-template-columns: auto 1fr auto 1fr;
    gap: 6px;
    align-items: center;
    font-size: 12px;
}
.ps-clone-downstream-row code {
    background: #eef;
    padding: 1px 6px;
    border-radius: 3px;
}
.ps-clone-downstream-name { min-width: 160px; }

/* ---- Shared picker-trigger styles (button that looks like a readonly input) ---- */
.ps-picker-row {
    display: flex;
    gap: 6px;
    align-items: center;
    flex-wrap: wrap;
}
.ps-picker-display {
    text-align: left;
    cursor: pointer;
    font-family: inherit;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.ps-picker-display em {
    color: var(--text-secondary, #888);
    font-style: italic;
}
.ps-picker-display:hover {
    background: var(--bg-hover, #f5f5f5);
    border-color: var(--accent-color, #0066cc);
}
.ps-picker-display:focus {
    outline: 2px solid var(--accent-color, #0066cc);
    outline-offset: -2px;
}

.ps-picker-display .ps-picker-id {
    color: var(--text-secondary, #888);
    font-family: monospace;
    font-size: 10px;
    margin-left: 6px;
    font-weight: normal;
}
`, "",{"version":3,"sources":["webpack://./src/pipeline-sandbox.css"],"names":[],"mappings":"AAEA;;;;8EAI8E;AAC9E;IACI,gCAAgC;AACpC;;AAEA;;;qEAGqE;AACrE;IACI,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;IACpC,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;IACpC,aAAa;IACb,sBAAsB;IACtB,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA,mBAAmB;AACnB;IACI,OAAO;IACP,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;IACjB,qDAAqD;AACzD;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,iCAAiC,mBAAmB,EAAE,cAAc,EAAE;AACtE,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;;AAExE;4DAC4D;AAC5D;IACI,kBAAkB;IAClB,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;iFACiF;AACjF;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;AACA,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;;AAEpE;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,MAAM;IACN,qDAAqD;IACrD,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA,0BAA0B,SAAS,EAAE;;AAErC;IACI,iBAAiB;IACjB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,kCAAkC;AACtC;;AAEA,gBAAgB,WAAW,EAAE;;AAE7B;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;AACA,0BAA0B,gBAAgB,EAAE;;AAE5C;IACI,OAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,gEAAgE;IAChE,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,gBAAgB,EAAE;AAC5C,0BAA0B,qBAAqB,EAAE;AACjD,8BAA8B,cAAc,EAAE;AAC9C,8BAA8B,cAAc,EAAE;AAC9C,8BAA8B,cAAc,EAAE;AAC9C,8BAA8B,cAAc,EAAE;;AAE9C,uDAAuD,cAAc,EAAE;AACvE,uDAAuD,cAAc,EAAE;AACvE,wDAAwD,cAAc,EAAE;AACxE,wDAAwD,WAAW,EAAE;AACrE,2DAA2D,WAAW,EAAE;;AAExE,iBAAiB;AACjB;IACI,SAAS;IACT,aAAa;IACb,gEAAgE;IAChE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,OAAO;IACP,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gEAAgE;IAChE,eAAe;IACf,YAAY;IACZ,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kDAAkD;IAClD,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mCAAmC;IACnC,cAAc;IACd,gEAAgE;IAChE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,gBAAgB;AAChB,kBAAkB,aAAa,EAAE,cAAc,EAAE;AACjD,oBAAoB,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE;AACnF,wBAAwB,WAAW,EAAE,eAAe,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAC3F,oBAAoB,mBAAmB,EAAE;AACzC,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AACjH,iBAAiB,aAAa,EAAE,4DAA4D,EAAE,SAAS,EAAE;AACzG,gBAAgB,mCAAmC,EAAE,kBAAkB,EAAE,aAAa,EAAE,kBAAkB,EAAE;AAC5G,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACxE,iBAAiB,eAAe,EAAE,WAAW,EAAE;AAC/C,kBAAkB,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE;AAC3E,yCAAyC,iBAAiB,EAAE,gBAAgB,EAAE,qDAAqD,EAAE;AACrI,qBAAqB,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE,WAAW,EAAE;;AAEhG,cAAc;AACd;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,mCAAmC;AACvC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;AAEA,yBAAyB,aAAa,EAAE;AACxC,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;;AAE/D,mBAAmB;AACnB;IACI,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,4CAA4C;IAC5C,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,kBAAkB;IAClB,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA;IACI,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA,0EAA0E;AAC1E;IACI,qDAAqD;AACzD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qDAAqD;IACrD,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,wCAAwC;IACxC,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,2CAA2C;IAC3C,kBAAkB;IAClB,mCAAmC;IACnC,gCAAgC;IAChC,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;AAEA,aAAa,oCAAoC,EAAE;AACnD,cAAc,sBAAsB,EAAE,wBAAwB,EAAE;AAChE,gBAAgB,YAAY,EAAE,eAAe,EAAE;;AAE/C;IACI,wCAAwC;IACxC,WAAW;IACX,0CAA0C;AAC9C;;AAEA,qBAAqB,mBAAmB,EAAE;AAC1C,sBAAsB,mBAAmB,EAAE;;AAE3C;IACI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA,oBAAoB,mBAAmB,EAAE;AACzC,qBAAqB,mBAAmB,EAAE;;AAE1C;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;AACA,mBAAmB,sBAAsB,EAAE;;AAE3C;IACI,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;AACA,6BAA6B,aAAa,EAAE;AAC5C;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,8CAA8C;IAC9C,kBAAkB;IAClB,uCAAuC;AAC3C;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,mCAAmC;IACnC,eAAe;IACf,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;IACpC,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,wCAAwC;IACxC,mDAAmD;IACnD,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,OAAO;AACX;;AAEA;IACI,OAAO;IACP,oDAAoD;IACpD,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA,iFAAiF;AACjF;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,aAAa;IACb,mCAAmC;IACnC,2CAA2C;IAC3C,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,oDAAoD;IACpD,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;IACzB,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA,qCAAqC;AACrC;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uCAAuC;AAC3C;AACA;IACI,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kDAAkD;IAClD,eAAe;AACnB;;AAEA,eAAe,iBAAiB,EAAE;;AAElC;kCACkC;AAClC,6BAA6B,WAAW,EAAE,sBAAsB,EAAE;AAClE,iDAAiD,YAAY,EAAE;;AAE/D,6EAA6E;AAC7E,wBAAwB,OAAO,EAAE,YAAY,EAAE;AAC/C,4CAA4C,OAAO,EAAE,eAAe,EAAE;AACtE,+CAA+C,OAAO,EAAE,eAAe,EAAE,aAAa,EAAE;AACxF,sDAAsD,aAAa,EAAE;;AAErE;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;IACzB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA,0BAA0B,OAAO,EAAE;;AAEnC;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA,2BAA2B,UAAU,EAAE;;AAEvC,0CAA0C;AAC1C;IACI,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;AACnB;AACA,0BAA0B,kCAAkC,EAAE;AAC9D,mBAAmB,0BAA0B,EAAE;;AAE/C,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;AACA,0BAA0B,eAAe,EAAE,kCAAkC,EAAE,cAAc,EAAE;AAC/F,4BAA4B,OAAO,EAAE,eAAe,EAAE;AACtD;IACI,OAAO,EAAE,eAAe;IACxB,wCAAwC,EAAE,kCAAkC;IAC5E,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB,yBAAyB,kBAAkB,EAAE;AAC7C,2BAA2B,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC5G;IACI,aAAa;IACb,4DAA4D;IAC5D,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;AACpB;AACA,mBAAmB,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAClJ,yBAAyB,cAAc,EAAE;;AAEzC;mFACmF;AACnF;;IAEI,aAAa;IACb,2FAA2F;IAC3F,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,kBAAkB;AACtB;AACA,yBAAyB,kBAAkB,EAAE;AAC7C;IACI,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA,4BAA4B,eAAe,EAAE,UAAU,EAAE;AACzD,0BAA0B,eAAe,EAAE;;AAE3C;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA,qBAAqB,OAAO,EAAE,eAAe,EAAE;AAC/C,kBAAkB,cAAc,EAAE,eAAe,EAAE;AACnD,qBAAqB,OAAO,EAAE,eAAe,EAAE;AAC/C,sBAAsB,OAAO,EAAE,eAAe,EAAE;;AAEhD;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,kCAAkC;IAClC,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA,wBAAwB,WAAW,EAAE;AACrC,yBAAyB,YAAY,EAAE;;AAEvC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kCAAkC;AACtC;;AAEA,0BAA0B,OAAO,EAAE;;AAEnC,kCAAkC;AAClC;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,iCAAiC;IACjC,gDAAgD;AACpD;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;IAClD,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;AACnB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,iCAAiC;IACjC,WAAW;IACX,uCAAuC;IACvC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,eAAe;IACf,mCAAmC;IACnC,gCAAgC;IAChC,2CAA2C;IAC3C,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;AACA,4BAA4B,oCAAoC,EAAE;AAClE,+BAA+B,wCAAwC,EAAE,WAAW,EAAE;AACtF;IACI,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,kCAAkC;AACtC;AACA;IACI,iCAAiC;IACjC,WAAW;AACf;AACA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA,yDAAyD;AACzD;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;AACA,qBAAqB,aAAa,EAAE;;AAEpC,mCAAmC;AACnC;IACI,OAAO;IACP,aAAa;IACb,sCAAsC;IACtC,MAAM;IACN,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,oDAAoD;IACpD,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;AACA,qCAAqC,kBAAkB,EAAE;;AAEzD;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,qDAAqD;IACrD,QAAQ;AACZ;AACA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kCAAkC;AACtC;AACA,iCAAiC,oCAAoC,EAAE;AACvE;IACI,oCAAoC;IACpC,+CAA+C;AACnD;AACA,gCAAgC,sBAAsB,EAAE;AACxD;IACI,iBAAiB;IACjB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,QAAQ;IACR,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,qDAAqD;IACrD,oCAAoC;AACxC;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kCAAkC;AACtC;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;AACA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,kDAAkD;IAClD,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;AACnB;AACA,gCAAgC,sBAAsB,EAAE;AACxD;IACI,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,wDAAwD;AACxD;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,kDAAkD;AACtD;AACA,2CAA2C,WAAW,EAAE,sBAAsB,EAAE;;AAEhF;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,mBAAmB;AACvB;AACA,0BAA0B,mBAAmB,EAAE;AAC/C;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,oEAAoE;IACpE,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,eAAe;IACf,kBAAkB;IAClB,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA,oDAAoD;AACpD;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,iDAAiD;IACjD,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA,0BAA0B,mBAAmB,EAAE,WAAW,EAAE;;AAE5D,sCAAsC;AACtC;IACI,qBAAqB;IACrB,wCAAwC;IACxC,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,iBAAiB;IACjB,kDAAkD;AACtD;AACA,4BAA4B,mBAAmB,EAAE;AACjD;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,eAAe;IACf,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,OAAO;IACP,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,mDAAmD;IACnD,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,wCAAwC;IACxC,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,QAAQ;IACR,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kDAAkD;IAClD,mCAAmC;AACvC;AACA;IACI,oBAAoB;IACpB,QAAQ;AACZ;AACA;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,wCAAwC;IACxC,WAAW;IACX,0CAA0C;AAC9C;AACA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,+BAA+B;IAC/B,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,mCAAmC;AACvC;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,wCAAwC;IACxC,WAAW;AACf;AACA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,+CAA+C;AACnD;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,iBAAiB;AACrB;AACA;IACI,OAAO;IACP,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,mCAAmC;AACvC;AACA;IACI,kDAAkD;AACtD;AACA;IACI,aAAa;IACb,wCAAwC;IACxC,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;AACA,yBAAyB,oCAAoC,EAAE;AAC/D,kBAAkB,kCAAkC,EAAE;AACtD,iBAAiB,gCAAgC,EAAE;AACnD;IACI,eAAe;IACf,kCAAkC;IAClC,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,OAAO;IACP,cAAc;IACd;;;KAGC;AACL;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA,gBAAgB,eAAe,EAAE;AACjC;IACI,UAAU;IACV,iCAAiC;IACjC,eAAe;AACnB;AACA,yCAAyC,iCAAiC,EAAE;AAC5E;IACI,sBAAsB;IACtB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,cAAc;IACd,UAAU;IACV,yBAAyB;AAC7B;AACA,gBAAgB,eAAe,EAAE;AACjC,2BAA2B,eAAe,EAAE;AAC5C;IACI,cAAc;IACd,iCAAiC;IACjC,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,cAAc;IACd,+CAA+C;IAC/C,kDAAkD;AACtD;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,eAAe;IACf,mBAAmB;IACnB,kDAAkD;AACtD;AACA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;AACvC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA,kBAAkB,iBAAiB,EAAE;AACrC;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,kDAAkD;AAClD;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,MAAM;IACN,qDAAqD;IACrD,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,oCAAoC;AACxC;AACA;IACI,gCAAgC;IAChC,iDAAiD;IACjD,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,eAAe;IACf,kCAAkC;IAClC,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,eAAe;IACf,mBAAmB;IACnB,kDAAkD;AACtD;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,2CAA2C;IAC3C,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,kCAAkC;AACtC;AACA;IACI,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;AACA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,wCAAwC;IACxC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,aAAa;IACb,wCAAwC;IACxC,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA,4BAA4B,gBAAgB,EAAE;;AAE9C,qFAAqF;AACrF;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,oCAAoC;IACpC,0CAA0C;AAC9C;AACA;IACI,+CAA+C;IAC/C,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":["@import url(\"./global.css\");\n\n/* Base text color for the whole shadow root — not just .ps-panel — because\n   some overlays (confirm/alert dialogs, the step-config modal, the function\n   detail popup) are appended directly to this.shadowRoot as siblings of\n   .ps-panel rather than nested inside it, so they never inherited .ps-panel's\n   own color rule and fell back to the page's ambient (non-dark) text color. */\n:host {\n    color: var(--text-primary, #333);\n}\n\n/* Dark theme for this developer tool only — scoped to :host(.hs-theme-dark)\n   rather than :root, so it never touches the main dashboard. Custom properties\n   inherit into every nested child (ml-models/ml-labeling/help-*),\n   which is why none of those files need their own dark-mode rules. */\n:host(.hs-theme-dark) {\n    --bg-primary: #1e1e1e;\n    --bg-secondary: #2a2a2a;\n    --bg-header: #14141f;\n    --bg-hover: #333333;\n    --bg-code: #151515;\n    --border-color: #3a3a3a;\n    --text-primary: #e8e8e8;\n    --text-secondary: #aaaaaa;\n    --accent-color: #4da3ff;\n    --danger: #ff6b6b;\n    --danger-color: #ff6b6b;\n    --warning-bg: #4a3c00;\n    --warning-border: #ffca28;\n    --warning-fg: #ffd54f;\n}\n\n.ps-backdrop {\n    position: fixed;\n    top: 0; left: 0; right: 0; bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n}\n\n.ps-panel {\n    position: fixed;\n    top: 0; left: 0; right: 0; bottom: 0;\n    display: flex;\n    flex-direction: column;\n    background: var(--bg-primary, #fff);\n    color: var(--text-primary, #333);\n    z-index: 1001;\n}\n\n.ps-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 16px;\n    background: var(--bg-header, #1a1a2e);\n    color: #fff;\n    min-height: 44px;\n}\n\n.ps-title {\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.header-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.ps-status {\n    font-size: 12px;\n    opacity: 0.8;\n}\n\n.ps-body {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.ps-view {\n    flex: 1;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n.ps-view.hidden {\n    display: none;\n}\n\n/* Toolbar */\n.ps-toolbar {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n}\n\n/* Pipeline table */\n.ps-pipeline-table {\n    flex: 1;\n    overflow: auto;\n    padding: 0 16px;\n}\n\n.ps-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n}\n\n.ps-table th,\n.ps-table td {\n    text-align: left;\n    padding: 8px 12px;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n}\n\n.ps-table th {\n    font-weight: 600;\n    color: var(--text-secondary, #666);\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.ps-table tr:hover {\n    background: var(--bg-hover, #f5f5f5);\n}\n\n.ps-pipeline-link {\n    color: var(--accent-color, #0066cc);\n    text-decoration: none;\n}\n\n.ps-pipeline-link:hover {\n    text-decoration: underline;\n}\n\n/* State badges */\n.ps-state-badge {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.ps-state-badge.state-running { background: #d4edda; color: #155724; }\n.ps-state-badge.state-stopped { background: #fff3cd; color: #856404; }\n.ps-state-badge.state-error   { background: #f8d7da; color: #721c24; }\n.ps-state-badge.state-creating { background: #d1ecf1; color: #0c5460; }\n.ps-state-badge.state-incomplete { background: #f8d7da; color: #721c24; }\n\n/* Why an incomplete pipeline could not restore — shown in the detail header so the\n   operator does not have to read server logs to find out. */\n.ps-detail-problems {\n    margin: 0 12px 8px;\n    padding: 8px 12px;\n    border-left: 3px solid #721c24;\n    background: #f8d7da;\n    color: #721c24;\n    font-size: 12px;\n}\n.ps-detail-problems .ps-detail-problem + .ps-detail-problem {\n    margin-top: 4px;\n}\n.ps-detail-problems code {\n    background: rgba(0, 0, 0, 0.06);\n    padding: 1px 4px;\n    border-radius: 3px;\n}\n\n/* Sandbox lifecycle badge — created from an older ELM version, ready for\n   cleanup rather than editing. Independent of the running/stopped state badge. */\n.ps-sandbox-badge {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    margin-left: 4px;\n}\n.ps-sandbox-badge.superseded { background: #e2e3e5; color: #383d41; }\n.ps-sandbox-badge.archived   { background: #e2e3e5; color: #383d41; }\n\n.ps-feature-badge {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-size: 11px;\n    background: var(--bg-secondary, #eef);\n    color: var(--text-secondary, #555);\n    margin-left: 4px;\n}\n\n.ps-evidence-panel {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px 20px;\n}\n\n/* Action buttons in table rows */\n.ps-row-actions {\n    display: flex;\n    gap: 4px;\n    align-items: center;\n}\n\n.ps-row-actions hs-toolbar-button,\n.ps-detail-actions hs-toolbar-button {\n    display: inline-flex;\n    align-items: center;\n}\n\n.ps-row-actions .btn,\n.ps-detail-actions .btn {\n    padding: 2px 8px;\n    font-size: 11px;\n}\n\n/* Detail view */\n.ps-detail-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n}\n\n.ps-detail-name {\n    font-size: 15px;\n    font-weight: 600;\n}\n\n.ps-detail-actions {\n    display: flex;\n    gap: 6px;\n    margin-left: auto;\n}\n\n.ps-detail-body {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n/* Tabs */\n.ps-detail-tabs {\n    display: flex;\n    gap: 0;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n    padding: 0 16px;\n}\n\n.ps-tab {\n    padding: 8px 16px;\n    border: none;\n    background: none;\n    cursor: pointer;\n    font-size: 13px;\n    color: var(--text-secondary, #666);\n    border-bottom: 2px solid transparent;\n}\n\n.ps-tab.active {\n    color: var(--text-primary, #333);\n    border-bottom-color: var(--accent-color, #0066cc);\n    font-weight: 600;\n}\n\n.ps-tab-panel {\n    flex: 1;\n    overflow: auto;\n}\n\n.ps-tab-panel.hidden {\n    display: none;\n}\n\n/* Log output */\n.ps-log-toolbar {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 16px;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n    flex-shrink: 0;\n}\n\n.ps-log-filters {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.ps-filter-toggle {\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    font-size: 11px;\n    cursor: pointer;\n}\n\n.ps-filter-toggle input { margin: 0; }\n\n.ps-log-count {\n    margin-left: auto;\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n}\n\n.ps-log-limit-label {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n}\n\n.ps-log-limit { width: 62px; }\n\n.ps-toggle-on {\n    background: var(--accent-color, #0066cc);\n    color: #fff;\n}\n\n.ps-log-test-bar {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 16px;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n    flex-shrink: 0;\n    background: var(--bg-secondary, #f8f8f8);\n}\n.ps-log-test-bar select { max-width: 220px; }\n\n.ps-log-output {\n    flex: 1;\n    overflow-y: auto;\n    padding: 8px 16px;\n    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace;\n    font-size: 12px;\n    line-height: 1.5;\n    background: var(--bg-code, #1e1e1e);\n    color: #d4d4d4;\n}\n\n.ps-log-placeholder {\n    color: #888;\n    font-style: italic;\n    padding: 20px;\n    text-align: center;\n}\n\n.ps-log-line {\n    white-space: pre-wrap;\n    word-break: break-all;\n}\n\n.ps-log-line .log-ts    { color: #6a9955; }\n.ps-log-line .log-level { font-weight: 600; }\n.ps-log-line .log-msg   { white-space: pre-wrap; }\n.ps-log-line .log-json-key  { color: #9cdcfe; }\n.ps-log-line .log-json-str  { color: #ce9178; }\n.ps-log-line .log-json-num  { color: #b5cea8; }\n.ps-log-line .log-json-bool { color: #569cd6; }\n\n.ps-level-error, .ps-log-line.level-error .log-level { color: #f44747; }\n.ps-level-warn,  .ps-log-line.level-warn .log-level  { color: #cca700; }\n.ps-level-info,  .ps-log-line.level-info .log-level   { color: #4fc1ff; }\n.ps-level-debug, .ps-log-line.level-debug .log-level  { color: #888; }\n.ps-level-verbose, .ps-log-line.level-verbose .log-level { color: #666; }\n\n/* Config panel */\n.ps-config-content {\n    margin: 0;\n    padding: 16px;\n    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace;\n    font-size: 12px;\n    line-height: 1.5;\n    white-space: pre-wrap;\n    overflow: auto;\n}\n\n/* Test panel */\n.ps-test-panel {\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.ps-test-cases-bar {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n.ps-test-case-select {\n    flex: 1;\n    max-width: 300px;\n}\n.ps-test-desc {\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n    font-style: italic;\n}\n\n.ps-test-save-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-top: 8px;\n}\n\n.ps-test-editing-label {\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n}\n\n.ps-test-action-buttons {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.ps-test-label {\n    font-size: 12px;\n    font-weight: 600;\n    margin-bottom: 4px;\n}\n\n.ps-test-textarea {\n    width: 100%;\n    min-height: 120px;\n    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace;\n    font-size: 12px;\n    padding: 8px;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 4px;\n    resize: vertical;\n    box-sizing: border-box;\n}\n\n.ps-test-output {\n    border-top: 1px solid var(--border-color, #e0e0e0);\n    padding-top: 12px;\n}\n\n.ps-test-result {\n    margin: 0;\n    padding: 12px;\n    background: var(--bg-code, #1e1e1e);\n    color: #d4d4d4;\n    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace;\n    font-size: 12px;\n    line-height: 1.5;\n    white-space: pre-wrap;\n    border-radius: 4px;\n    max-height: 300px;\n    overflow: auto;\n}\n\n/* Stats panel */\n.ps-stats-panel { padding: 16px; overflow: auto; }\n.ps-stats-toolbar { display: flex; justify-content: flex-end; margin-bottom: 12px; }\n.ps-stats-placeholder { color: #888; font-size: 13px; padding: 24px 0; text-align: center; }\n.ps-stats-section { margin-bottom: 20px; }\n.ps-stats-title { font-size: 12px; font-weight: 600; text-transform: uppercase; color: #666; margin-bottom: 8px; }\n.ps-stats-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 10px; }\n.ps-stat-card { background: var(--bg-code, #f5f5f5); border-radius: 6px; padding: 12px; text-align: center; }\n.ps-stat-value { font-size: 18px; font-weight: 600; margin-bottom: 4px; }\n.ps-stat-label { font-size: 11px; color: #888; }\n.ps-stats-table { width: 100%; border-collapse: collapse; font-size: 13px; }\n.ps-stats-table th, .ps-stats-table td { padding: 6px 10px; text-align: left; border-bottom: 1px solid var(--border-color, #e0e0e0); }\n.ps-stats-table th { font-weight: 600; font-size: 11px; text-transform: uppercase; color: #666; }\n\n/* Form view */\n.ps-form-body {\n    padding: 16px;\n    max-width: 640px;\n    overflow: auto;\n}\n\n.ps-form-group {\n    margin-bottom: 16px;\n}\n\n.ps-form-group > label {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    margin-bottom: 4px;\n}\n\n.ps-form-hint {\n    display: block;\n    font-size: 11px;\n    color: var(--text-secondary, #888);\n    margin-top: 2px;\n}\n\n.ps-input {\n    width: 100%;\n    padding: 6px 8px;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 4px;\n    font-size: 13px;\n    box-sizing: border-box;\n    color: inherit;\n    background: var(--bg-primary, #fff);\n}\n\n.ps-input-sm {\n    width: 80px;\n}\n\n.ps-topic-row {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n}\n.ps-topic-row .ps-input {\n    flex: 1;\n}\n\n.ps-radio-group {\n    display: flex;\n    gap: 16px;\n    font-size: 13px;\n}\n\n.ps-pipeline-steps {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 8px;\n}\n\n.ps-step-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.ps-step-row .ps-input {\n    flex: 1;\n}\n\n.ps-step-row .btn-icon {\n    flex-shrink: 0;\n}\n\n.ps-form-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n    font-size: 13px;\n}\n\n.ps-form-advanced.hidden {\n    display: none;\n}\n\n.ps-form-actions {\n    display: flex;\n    gap: 8px;\n    margin-top: 16px;\n}\n\n.ps-form-result {\n    margin-top: 12px;\n    padding: 10px;\n    border-radius: 4px;\n    font-size: 12px;\n    white-space: pre-wrap;\n}\n\n.ps-form-result.hidden { display: none; }\n.ps-form-result.valid   { background: #d4edda; color: #155724; }\n.ps-form-result.invalid { background: #f8d7da; color: #721c24; }\n\n/* Plugin manager */\n.ps-plugin-toolbar {\n    padding: 10px 16px;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n}\n\n.ps-upload-zone {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 16px;\n    border: 2px dashed var(--border-color, #ccc);\n    border-radius: 6px;\n    font-size: 13px;\n    color: var(--text-secondary, #666);\n    text-align: center;\n    justify-content: center;\n    transition: border-color 0.15s, background 0.15s;\n}\n\n.ps-upload-zone.drag-over {\n    border-color: var(--accent-color, #0066cc);\n    background: rgba(0, 102, 204, 0.05);\n}\n\n/* Topic subscriptions — neutral presentation, not a warning/error state */\n.ps-subscriptions-section {\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n}\n\n.ps-subscriptions-summary {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 16px;\n    background: none;\n    border: none;\n    font-size: 13px;\n    color: var(--text-secondary, #666);\n    cursor: pointer;\n    text-align: left;\n}\n\n.ps-subscriptions-caret {\n    transition: transform 0.15s;\n}\n\n.ps-subscriptions-summary.expanded .ps-subscriptions-caret {\n    transform: rotate(180deg);\n}\n\n.ps-subscriptions-detail {\n    padding: 0 16px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.ps-subscriptions-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    max-height: 160px;\n    overflow-y: auto;\n    font-size: 12px;\n    font-family: monospace;\n    color: var(--text-secondary, #666);\n}\n\n.ps-subscriptions-list li {\n    padding: 2px 0;\n}\n\n.ps-plugin-list {\n    flex: 1;\n    overflow: auto;\n    padding: 0 16px;\n}\n\n.ps-plugin-card {\n    padding: 10px 0;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.ps-plugin-name {\n    font-weight: 600;\n    font-size: 13px;\n}\n\n.ps-plugin-exports {\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n    margin-top: 2px;\n}\n\n.ps-plugin-info {\n    flex: 1;\n    min-width: 0;\n}\n\n.ps-plugin-desc {\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n    margin-top: 3px;\n    line-height: 1.4;\n}\n\n.ps-fn-list {\n    margin-top: 6px;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.ps-fn-row {\n    font-size: 11px;\n    display: flex;\n    align-items: baseline;\n    gap: 5px;\n    flex-wrap: wrap;\n}\n\n.ps-fn-name {\n    font-weight: 600;\n    color: var(--text-primary, #333);\n    flex-shrink: 0;\n}\n\n.ps-fn-badge {\n    font-size: 9px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    background: var(--bg-secondary, #f0f0f0);\n    color: var(--text-secondary, #777);\n    border-radius: 3px;\n    padding: 1px 4px;\n    flex-shrink: 0;\n}\n\n.ps-fn-desc {\n    color: var(--text-secondary, #888);\n    font-style: italic;\n}\n\n.ps-plugin-actions {\n    display: flex;\n    gap: 4px;\n    flex-shrink: 0;\n}\n\n/* Empty state */\n.ps-empty-state {\n    padding: 40px 16px;\n    text-align: center;\n    color: var(--text-secondary, #888);\n    font-size: 13px;\n}\n\n/* Shared button styles */\n.btn {\n    padding: 6px 12px;\n    border: 1px solid var(--border-color, #ccc);\n    border-radius: 4px;\n    background: var(--bg-primary, #fff);\n    color: var(--text-primary, #333);\n    cursor: pointer;\n    font-size: 12px;\n    white-space: nowrap;\n}\n\n.btn:hover { background: var(--bg-hover, #f0f0f0); }\n.btn:active { transform: scale(0.96); filter: brightness(0.92); }\n.btn:disabled { opacity: 0.5; cursor: default; }\n\n.btn-primary {\n    background: var(--accent-color, #0066cc);\n    color: #fff;\n    border-color: var(--accent-color, #0066cc);\n}\n\n.btn-primary:hover { background: #005bb5; }\n.btn-primary:active { background: #004a99; }\n\n.btn-secondary {\n    background: var(--bg-secondary, #f5f5f5);\n}\n\n.btn-danger {\n    color: #d32f2f;\n    border-color: #d32f2f;\n}\n\n.btn-danger:hover { background: #fbe9e7; }\n.btn-danger:active { background: #f5d0cc; }\n\n.btn-sm {\n    padding: 3px 8px;\n    font-size: 11px;\n}\n\n.btn-icon {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 18px;\n    padding: 4px;\n    color: inherit;\n}\n.btn-icon:active { transform: scale(0.85); }\n\n.ps-loading-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(255, 255, 255, 0.55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 500;\n}\n.ps-loading-overlay.hidden { display: none; }\n.ps-spinner {\n    width: 28px;\n    height: 28px;\n    border: 3px solid #e0e0e0;\n    border-top-color: var(--accent-color, #0066cc);\n    border-radius: 50%;\n    animation: ps-spin 0.7s linear infinite;\n}\n@keyframes ps-spin { to { transform: rotate(360deg); } }\n\n.link-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: var(--accent-color, #0066cc);\n    font-size: 12px;\n    padding: 0;\n    text-decoration: underline;\n}\n\n.hidden {\n    display: none !important;\n}\n\n/* Confirm dialog overlay */\n.ps-confirm-overlay {\n    position: fixed;\n    top: 0; left: 0; right: 0; bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1100;\n}\n\n.ps-confirm-dialog {\n    background: var(--bg-primary, #fff);\n    border-radius: 8px;\n    padding: 20px;\n    max-width: 360px;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.15);\n}\n\n.ps-confirm-dialog p {\n    margin: 0 0 16px;\n    font-size: 13px;\n}\n\n.ps-confirm-dialog .ps-confirm-actions {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-end;\n}\n\n#ps-prompt-input {\n    width: 100%;\n    margin-bottom: 12px;\n    box-sizing: border-box;\n}\n\n.ps-alert-dialog {\n    max-width: 600px;\n}\n.ps-alert-content {\n    margin: 0 0 16px;\n    font-size: 13px;\n    white-space: pre-wrap;\n    word-break: break-word;\n    max-height: 60vh;\n    overflow: auto;\n}\n\n.ps-builder-main {\n    flex: 1;\n    overflow-y: auto;\n}\n\n.ps-scratch-notice {\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n    background: var(--bg-secondary, #f5f5f5);\n    border-left: 3px solid var(--accent-color, #0066cc);\n    padding: 8px 12px;\n    margin-bottom: 16px;\n}\n.ps-scratch-notice code {\n    background: #eef;\n    padding: 1px 6px;\n    border-radius: 3px;\n}\n\n.ps-add-step-row {\n    display: flex;\n    gap: 6px;\n    margin-bottom: 8px;\n}\n.ps-add-step-row select {\n    flex: 1;\n}\n\n.ps-step-ref {\n    flex: 1;\n    font-family: 'SF Mono', 'Menlo', 'Monaco', monospace;\n    font-size: 12px;\n    color: var(--text-primary, #333);\n    padding: 4px 8px;\n    background: var(--bg-secondary, #f5f5f5);\n    border-radius: 3px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n}\n\n.ps-step-tap {\n    display: none;\n}\n\n/* Configure button — tuning mode only (see sandbox-refocus-view-tune.md § 4.1) */\n.ps-step-configure {\n    font-size: 10px;\n    flex-shrink: 0;\n}\n\n/* Step config popover */\n.ps-step-popover {\n    position: fixed;\n    z-index: 1100;\n    background: var(--bg-primary, #fff);\n    border: 1px solid var(--border-color, #ccc);\n    border-radius: 6px;\n    box-shadow: 0 4px 16px rgba(0,0,0,0.12);\n    padding: 12px;\n    min-width: 280px;\n}\n\n.ps-popover-content .ps-form-row {\n    margin-bottom: 6px;\n}\n\n.ps-popover-content .ps-form-row label {\n    min-width: 80px;\n    font-size: 11px;\n}\n\n.ps-form-row-label {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-secondary, #666);\n    margin: 8px 0 2px;\n}\n\n.ps-opts-textarea {\n    width: 100%;\n    min-height: 60px;\n    font-family: 'SF Mono', 'Menlo', 'Monaco', monospace;\n    font-size: 11px;\n    resize: vertical;\n    box-sizing: border-box;\n}\n\n.ps-popover-actions {\n    display: flex;\n    gap: 6px;\n    justify-content: flex-end;\n    margin-top: 8px;\n}\n\n/* Plugin category header */\n.ps-plugin-category-header {\n    padding: 8px 0 4px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--text-secondary, #888);\n    border-bottom: 1px solid var(--border-color, #eee);\n}\n\n.ps-plugin-label {\n    font-size: 11px;\n    color: var(--text-secondary, #888);\n}\n\n/* Configurable plugin config panel */\n.ps-cfg-panel {\n    border: 1px solid var(--border-color, #ddd);\n    border-radius: 6px;\n    margin: 4px 0 8px;\n    background: var(--bg-primary, #fafafa);\n    box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n\n.ps-cfg-modal {\n    background: var(--bg-primary, #fff);\n    border-radius: 8px;\n    width: 90%;\n    max-width: 600px;\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.15);\n}\n.ps-cfg-modal .ps-cfg-body {\n    overflow-y: auto;\n    flex: 1;\n}\n\n.ps-cfg-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n    border-bottom: 1px solid var(--border-color, #eee);\n    font-size: 12px;\n}\n\n.ps-cfg-body { padding: 8px 12px; }\n\n/* Widen ps-input-sm inputs inside the config modal so placeholders aren't truncated.\n   Keeps numeric inputs compact. */\n.ps-cfg-modal .ps-input-sm { width: 100%; box-sizing: border-box; }\n.ps-cfg-modal input[type=\"number\"].ps-input-sm { width: 100px; }\n\n/* Field-picker cell fills its slot in kv rows / list items / filter rules. */\n.ps-field-picker-cell { flex: 1; min-width: 0; }\n.ps-cfg-filter-rule .ps-field-picker-cell { flex: 2; min-width: 80px; }\n.ps-cfg-filter-rule .ps-cfg-rule-vfield-wrap { flex: 2; min-width: 60px; display: flex; }\n.ps-cfg-filter-rule .ps-cfg-rule-vfield-wrap.hidden { display: none; }\n\n.ps-cfg-footer {\n    display: flex;\n    gap: 6px;\n    justify-content: flex-end;\n    padding: 8px 12px;\n    border-top: 1px solid var(--border-color, #eee);\n}\n\n.ps-cfg-section {\n    margin-bottom: 10px;\n}\n\n.ps-cfg-section > label {\n    display: block;\n    font-size: 11px;\n    font-weight: 600;\n    margin-bottom: 4px;\n    color: var(--text-secondary, #555);\n}\n\n.ps-cfg-toggles {\n    display: flex;\n    gap: 16px;\n}\n\n.ps-cfg-toggles label {\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n/* Key-value rows (rename, match) */\n.ps-cfg-kv-row, .ps-cfg-set-row {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-bottom: 3px;\n}\n\n.ps-cfg-kv-row span, .ps-cfg-set-row span {\n    font-size: 11px;\n    color: var(--text-secondary, #999);\n    flex-shrink: 0;\n}\n\n.ps-cfg-kv-row input, .ps-cfg-set-row input[type=\"text\"] {\n    flex: 1;\n    min-width: 60px;\n}\n\n.ps-cfg-set-row label {\n    font-size: 10px;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    flex-shrink: 0;\n    color: var(--text-secondary, #888);\n}\n\n.ps-cfg-list-item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-bottom: 3px;\n}\n\n.ps-cfg-list-item input { flex: 1; }\n\n.ps-cfg-row-remove {\n    font-size: 12px;\n    opacity: 0.5;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.ps-cfg-row-remove:hover { opacity: 1; }\n\n/* Enrich source label + required marker */\n.ps-cfg-source-label {\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    background: var(--bg-secondary, #f0f0f0);\n    cursor: default;\n}\n.ps-cfg-source-label em { color: var(--text-secondary, #999); }\n.ps-cfg-required { color: var(--danger, #c00); }\n\n/* Enrich match pairs */\n.ps-cfg-match-pair {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 4px;\n}\n.ps-cfg-match-pair span { font-size: 11px; color: var(--text-secondary, #999); flex-shrink: 0; }\n.ps-cfg-match-pair select { flex: 1; min-width: 80px; }\n.ps-cfg-match-pair .ps-cfg-match-right {\n    flex: 1; min-width: 80px;\n    background: var(--bg-secondary, #f0f0f0); color: var(--text-secondary, #666);\n    cursor: not-allowed;\n}\n\n/* Enrich fields grid */\n.ps-cfg-field-controls { margin-bottom: 6px; }\n.ps-cfg-select-all-label { font-size: 11px; display: flex; align-items: center; gap: 4px; font-weight: 600; }\n.ps-cfg-field-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n    gap: 2px 12px;\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid var(--border-color, #eee);\n    border-radius: 4px;\n    padding: 6px 8px;\n}\n.ps-cfg-field-cb { font-size: 12px; display: flex; align-items: center; gap: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.ps-cfg-field-cb input { flex-shrink: 0; }\n\n/* Shared per-field join projection list (enrich + flatMap): Merge as / On miss /\n   Default / If present per selected field, plus a trailing remove-button column. */\n.ps-cfg-projection-header,\n.ps-cfg-projection-row {\n    display: grid;\n    grid-template-columns: minmax(70px, 1fr) minmax(70px, 1fr) 90px minmax(80px, 1fr) 90px 20px;\n    gap: 6px;\n    align-items: center;\n}\n.ps-cfg-projection-header {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    color: var(--text-secondary, #999);\n    margin-bottom: 4px;\n}\n.ps-cfg-projection-row { margin-bottom: 4px; }\n.ps-cfg-projection-source {\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.ps-cfg-projection-remove { font-size: 12px; padding: 0; }\n.ps-cfg-join-add-manual { margin-top: 4px; }\n\n.ps-cfg-join-defaults-row {\n    display: flex;\n    gap: 16px;\n    flex-wrap: wrap;\n}\n.ps-cfg-join-defaults-row label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n}\n\n/* Filter rule rows */\n.ps-cfg-filter-rule {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-bottom: 4px;\n    flex-wrap: wrap;\n}\n\n.ps-cfg-rule-field { flex: 2; min-width: 80px; }\n.ps-cfg-rule-op { flex: 0 0 auto; min-width: 70px; }\n.ps-cfg-rule-value { flex: 2; min-width: 60px; }\n.ps-cfg-rule-vfield { flex: 2; min-width: 60px; }\n\n.ps-cfg-rule-dyn {\n    font-size: 10px;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    flex-shrink: 0;\n    color: var(--text-secondary, #888);\n}\n\n.ps-cfg-rule-invert {\n    font-size: 10px;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    flex-shrink: 0;\n    color: var(--text-secondary, #888);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n.ps-cfg-rule-invert:has(input:checked) {\n    color: var(--danger, #c00);\n    font-weight: 600;\n}\n\n/* Window form extras */\n.ps-cfg-dur-row {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n}\n\n.ps-cfg-dur-row input { width: 80px; }\n.ps-cfg-dur-row select { width: 100px; }\n\n.ps-cfg-kv-inline {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 4px;\n}\n\n.ps-cfg-kv-inline label {\n    font-size: 11px;\n    min-width: 60px;\n    color: var(--text-secondary, #666);\n}\n\n.ps-cfg-kv-inline input { flex: 1; }\n\n/* -- Warning / hint callouts -- */\n.ps-cfg-warning {\n    display: block;\n    padding: 6px 10px;\n    margin-top: 6px;\n    border-radius: 4px;\n    font-size: 12px;\n    line-height: 1.4;\n    background: var(--warning-bg, #fff3cd);\n    color: var(--warning-fg, #856404);\n    border: 1px solid var(--warning-border, #ffc107);\n}\n\n.ps-cfg-warning code {\n    background: rgba(0,0,0,.06);\n    padding: 1px 4px;\n    border-radius: 3px;\n    font-size: 11px;\n}\n\n.ps-cfg-perf-guide .ps-form-hint {\n    line-height: 1.7;\n}\n\n.ps-cfg-compact-section {\n    border-top: 1px solid var(--border-color, #e0e0e0);\n    margin-top: 8px;\n    padding-top: 8px;\n}\n\n.ps-cfg-db-warning,\n.ps-cfg-scan-warning {\n    margin-top: 4px;\n}\n\n/* ---- Namespace selector (header) ---- */\n.ps-namespace-selector {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: rgba(255,255,255,0.85);\n}\n.ps-namespace-label {\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    opacity: 0.7;\n}\n.ps-namespace-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: rgba(255,255,255,0.1);\n    color: #fff;\n    border: 1px solid rgba(255,255,255,0.2);\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    font-family: monospace;\n    min-width: 120px;\n    justify-content: space-between;\n}\n.ps-namespace-btn:hover {\n    background: rgba(255,255,255,0.18);\n}\n.ps-namespace-caret {\n    font-size: 10px;\n    opacity: 0.7;\n}\n.ps-ns-popover {\n    position: fixed;\n    background: var(--bg-primary, #fff);\n    color: var(--text-primary, #333);\n    border: 1px solid var(--border-color, #ccc);\n    border-radius: 6px;\n    box-shadow: 0 4px 16px rgba(0,0,0,0.18);\n    padding: 10px;\n    z-index: 1200;\n    min-width: 260px;\n    max-width: 360px;\n    font-size: 12px;\n}\n.ps-ns-popover-title {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--text-secondary, #666);\n    margin-bottom: 6px;\n}\n.ps-ns-popover-input {\n    width: 100%;\n    box-sizing: border-box;\n    font-family: monospace;\n    margin-bottom: 8px;\n}\n.ps-ns-popover-list {\n    max-height: 240px;\n    overflow-y: auto;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 4px;\n    margin-bottom: 8px;\n}\n.ps-ns-popover-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 10px;\n    cursor: pointer;\n    font-family: monospace;\n}\n.ps-ns-popover-item:hover { background: var(--bg-hover, #f5f5f5); }\n.ps-ns-popover-item.selected { background: var(--accent-color, #0066cc); color: #fff; }\n.ps-ns-popover-item-badge {\n    margin-left: auto;\n    font-family: sans-serif;\n    font-size: 10px;\n    padding: 1px 6px;\n    border-radius: 8px;\n    background: var(--bg-hover, #eee);\n    color: var(--text-secondary, #666);\n}\n.ps-ns-popover-item.selected .ps-ns-popover-item-badge {\n    background: rgba(255,255,255,0.2);\n    color: #fff;\n}\n.ps-ns-popover-actions {\n    display: flex;\n    gap: 6px;\n    justify-content: flex-end;\n}\n.ps-ns-popover-hint {\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n    margin-bottom: 6px;\n}\n\n/* Small pill in view headers showing current namespace */\n.ps-ns-badge {\n    display: inline-block;\n    padding: 2px 8px;\n    background: var(--bg-hover, #eef);\n    color: var(--text-secondary, #446);\n    border-radius: 10px;\n    font-family: monospace;\n    font-size: 11px;\n    margin-left: 8px;\n}\n.ps-ns-badge:empty { display: none; }\n\n/* ---- Schema Explorer (v2) ---- */\n.ps-schema-explorer-layout {\n    flex: 1;\n    display: grid;\n    grid-template-columns: 220px 320px 1fr;\n    gap: 0;\n    overflow: hidden;\n    min-height: 0;\n}\n\n.ps-schema-explorer-col {\n    border-right: 1px solid var(--border-color, #e0e0e0);\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n}\n.ps-schema-explorer-col:last-child { border-right: none; }\n\n.ps-schema-explorer-col-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--text-secondary, #666);\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n    gap: 8px;\n}\n.ps-schema-explorer-col-header .ps-input {\n    text-transform: none;\n    letter-spacing: 0;\n    font-weight: 400;\n}\n\n.ps-schema-explorer-list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 4px 0;\n}\n\n.ps-schema-explorer-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    cursor: pointer;\n    font-size: 13px;\n    border-left: 3px solid transparent;\n}\n.ps-schema-explorer-item:hover { background: var(--bg-hover, #f5f5f5); }\n.ps-schema-explorer-item.selected {\n    background: var(--bg-hover, #eaf1fb);\n    border-left-color: var(--accent-color, #0066cc);\n}\n.ps-schema-explorer-item-name { font-family: monospace; }\n.ps-schema-explorer-item-meta {\n    margin-left: auto;\n    font-size: 10px;\n    color: var(--text-secondary, #666);\n}\n\n.ps-schema-explorer-item-badges {\n    display: inline-flex;\n    gap: 4px;\n    margin-left: auto;\n}\n.ps-schema-explorer-badge {\n    font-size: 10px;\n    padding: 1px 6px;\n    border-radius: 8px;\n    background: #eee;\n    color: #555;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n.ps-schema-explorer-badge-prod {\n    background: #e2f0ff;\n    color: #0055aa;\n}\n.ps-schema-explorer-badge-overlay {\n    background: #fff2cc;\n    color: #7a5b00;\n}\n.ps-schema-explorer-badge-sandbox {\n    background: #e6f4ea;\n    color: #1b6b2f;\n}\n\n.ps-schema-explorer-common {\n    padding: 8px 12px;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n    background: var(--bg-hover, #fafafa);\n}\n.ps-schema-explorer-common-title {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--text-secondary, #666);\n    margin-bottom: 4px;\n}\n.ps-schema-explorer-common-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n}\n.ps-schema-explorer-common-chip {\n    font-family: monospace;\n    font-size: 11px;\n    padding: 1px 6px;\n    background: #eef;\n    color: #337;\n    border-radius: 3px;\n    cursor: help;\n}\n\n.ps-schema-explorer-detail-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 12px 16px;\n}\n.ps-schema-explorer-detail-header {\n    display: flex;\n    align-items: baseline;\n    gap: 10px;\n    margin-bottom: 4px;\n}\n.ps-schema-explorer-detail-name {\n    font-family: monospace;\n    font-size: 16px;\n    font-weight: 600;\n}\n.ps-schema-explorer-detail-version {\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n}\n.ps-schema-explorer-detail-desc {\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n    margin-bottom: 12px;\n}\n.ps-schema-explorer-detail-section {\n    margin-top: 14px;\n}\n.ps-schema-explorer-detail-section-title {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--text-secondary, #666);\n    margin-bottom: 6px;\n}\n.ps-schema-explorer-prop-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12px;\n}\n.ps-schema-explorer-prop-table th,\n.ps-schema-explorer-prop-table td {\n    text-align: left;\n    padding: 4px 8px;\n    border-bottom: 1px solid var(--border-color, #eee);\n    vertical-align: top;\n}\n.ps-schema-explorer-prop-table th {\n    font-weight: 600;\n    color: var(--text-secondary, #666);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    font-size: 10px;\n}\n.ps-schema-explorer-prop-name { font-family: monospace; }\n.ps-schema-explorer-prop-type {\n    font-family: monospace;\n    color: #06c;\n}\n.ps-schema-explorer-storage {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    font-size: 11px;\n}\n.ps-schema-explorer-storage-item {\n    padding: 2px 8px;\n    background: var(--bg-hover, #f5f5f5);\n    border-radius: 4px;\n    font-family: monospace;\n}\n.ps-schema-explorer-raw {\n    background: #1a1a2e;\n    color: #eee;\n    padding: 10px;\n    border-radius: 4px;\n    font-size: 11px;\n    max-height: 260px;\n    overflow: auto;\n    white-space: pre;\n    font-family: monospace;\n}\n\n/* ---- Schema Explorer editor + actions (step 2) ---- */\n.ps-schema-explorer-col-actions {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    text-transform: none;\n    letter-spacing: 0;\n    font-weight: 400;\n}\n.ps-schema-explorer-filter-row {\n    padding: 6px 12px;\n    border-bottom: 1px solid var(--border-color, #eee);\n}\n.ps-schema-explorer-filter-row .ps-input { width: 100%; box-sizing: border-box; }\n\n.ps-schema-editor-toolbar {\n    margin-bottom: 8px;\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    flex-wrap: wrap;\n}\n.ps-schema-editor-common-note {\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n    background: #fafafa;\n    padding: 6px 8px;\n    border-radius: 4px;\n    margin-bottom: 10px;\n}\n.ps-schema-editor-grid {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 8px;\n    margin-bottom: 10px;\n}\n.ps-schema-editor-field { margin-bottom: 10px; }\n.ps-schema-editor-field > label {\n    display: block;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--text-secondary, #666);\n    margin-bottom: 4px;\n}\n.ps-schema-editor-label {\n    display: block;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--text-secondary, #666);\n    margin: 6px 0 4px;\n}\n.ps-schema-editor-storage-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n.ps-schema-editor-storage-row > label {\n    margin-bottom: 0;\n    margin-right: 6px;\n}\n.ps-schema-editor-inline {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 12px;\n    text-transform: none;\n    letter-spacing: 0;\n    color: inherit;\n}\n.ps-schema-editor-props-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 6px;\n}\n.ps-schema-editor-quickadd {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n}\n.ps-schema-editor-props {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n.ps-schema-editor-prop-row {\n    display: grid;\n    grid-template-columns: minmax(120px, 1.4fr) 100px 100px 1fr 1fr auto;\n    gap: 4px;\n    align-items: center;\n}\n.ps-schema-editor-prop-remove {\n    background: transparent;\n    border: 1px solid transparent;\n    color: var(--text-secondary, #888);\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 4px;\n}\n.ps-schema-editor-prop-remove:hover {\n    background: #ffecec;\n    color: #a00;\n    border-color: #f5c6c6;\n}\n.ps-schema-editor-raw {\n    width: 100%;\n    min-height: 320px;\n    font-family: monospace;\n    font-size: 12px;\n    padding: 8px;\n    box-sizing: border-box;\n    border: 1px solid var(--border-color, #ccc);\n    border-radius: 4px;\n    resize: vertical;\n}\n\n/* Copy-to-clipboard modal */\n.ps-copy-path {\n    font-size: 12px;\n    margin-bottom: 8px;\n    color: var(--text-secondary, #555);\n}\n.ps-copy-path code {\n    background: #eef;\n    padding: 1px 6px;\n    border-radius: 3px;\n    font-size: 11px;\n}\n.ps-copy-content {\n    background: #1a1a2e;\n    color: #eee;\n    font-family: monospace;\n    font-size: 12px;\n    padding: 10px;\n    border-radius: 4px;\n}\n\n/* ---- Outputs editor (builder form, step 3) ---- */\n.ps-form-outputs {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 6px;\n}\n.ps-form-output-row {\n    display: grid;\n    grid-template-columns: 1.4fr 1.4fr auto auto auto;\n    gap: 6px;\n    align-items: center;\n}\n.ps-output-remove {\n    background: transparent;\n    border: 1px solid transparent;\n    color: var(--text-secondary, #888);\n    cursor: pointer;\n    padding: 2px 6px;\n    border-radius: 4px;\n}\n.ps-output-remove:hover { background: #ffecec; color: #a00; }\n\n/* ---- Orphan cleanup (step 4) ---- */\n.ps-orphan-count {\n    display: inline-block;\n    background: var(--danger-color, #cc3333);\n    color: #fff;\n    font-size: 10px;\n    padding: 1px 6px;\n    border-radius: 8px;\n    margin-left: 4px;\n}\n.ps-orphan-list {\n    max-height: 320px;\n    overflow-y: auto;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 4px;\n    margin: 12px 0;\n}\n.ps-orphan-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 8px 12px;\n    border-bottom: 1px solid var(--border-color, #eee);\n}\n.ps-orphan-row:last-child { border-bottom: none; }\n.ps-orphan-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n.ps-orphan-ns {\n    font-family: monospace;\n    font-size: 13px;\n}\n.ps-orphan-count-inline {\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n}\n.ps-orphan-actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n/* ---- Telemetry drawer (step 5) ---- */\n.ps-logs-layout {\n    flex: 1;\n    display: flex;\n    min-height: 0;\n    overflow: hidden;\n}\n.ps-logs-main {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    overflow: hidden;\n}\n.ps-telemetry-drawer {\n    width: 420px;\n    border-left: 1px solid var(--border-color, #e0e0e0);\n    display: flex;\n    flex-direction: column;\n    flex-shrink: 0;\n    background: var(--bg-secondary, #fafafa);\n    overflow: hidden;\n    transition: width 0.15s ease;\n}\n.ps-telemetry-drawer.collapsed {\n    width: 0;\n    border-left: none;\n}\n.ps-telemetry-drawer-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 10px;\n    border-bottom: 1px solid var(--border-color, #eee);\n    background: var(--bg-primary, #fff);\n}\n.ps-telemetry-mode-toggle {\n    display: inline-flex;\n    gap: 4px;\n}\n.ps-tel-mode-btn {\n    background: transparent;\n    border: 1px solid var(--border-color, #ccc);\n    padding: 2px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n}\n.ps-tel-mode-btn.active {\n    background: var(--accent-color, #0066cc);\n    color: #fff;\n    border-color: var(--accent-color, #0066cc);\n}\n.ps-telemetry-drawer-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n.ps-tel-filters {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n.ps-tel-filter-row {\n    display: grid;\n    grid-template-columns: 90px 1fr;\n    gap: 6px;\n    align-items: center;\n}\n.ps-tel-filter-row-full {\n    grid-template-columns: 90px 1fr 1fr;\n}\n.ps-tel-filter-row label {\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n}\n.ps-tel-range-chips {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n    margin-top: 4px;\n}\n.ps-tel-chip {\n    font-size: 11px;\n    padding: 2px 8px;\n}\n.ps-tel-chip.active {\n    background: var(--accent-color, #0066cc);\n    color: #fff;\n}\n.ps-tel-actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    padding-top: 4px;\n    border-top: 1px solid var(--border-color, #eee);\n}\n.ps-tel-count {\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n    margin-left: auto;\n}\n.ps-tel-rows {\n    flex: 1;\n    overflow-y: auto;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 4px;\n    background: var(--bg-primary, #fff);\n}\n.ps-tel-row {\n    border-bottom: 1px solid var(--border-color, #eee);\n}\n.ps-tel-row-head {\n    display: grid;\n    grid-template-columns: 16px 1fr 1fr auto;\n    gap: 6px;\n    align-items: center;\n    padding: 4px 8px;\n    cursor: pointer;\n    font-size: 12px;\n    font-family: monospace;\n}\n.ps-tel-row-head:hover { background: var(--bg-hover, #f5f5f5); }\n.ps-tel-row-dom { color: var(--text-secondary, #666); }\n.ps-tel-row-mt { color: var(--accent-color, #06c); }\n.ps-tel-row-ts {\n    font-size: 11px;\n    color: var(--text-secondary, #888);\n    text-align: right;\n}\n.ps-tel-row-payload {\n    background: #1a1a2e;\n    color: #eee;\n    margin: 0;\n    padding: 8px 12px;\n    font-size: 11px;\n    max-height: 200px;\n    overflow: auto;\n    white-space: pre;\n}\n\n/* ---- Topology view (step 6) ---- */\n.ps-topology-body {\n    flex: 1;\n    overflow: auto;\n    background: repeating-linear-gradient(\n        0deg, #fafafa, #fafafa 24px,\n        #f0f0f0 24px, #f0f0f0 25px\n    );\n}\n.ps-topology-canvas {\n    min-height: 100%;\n    padding: 12px;\n}\n.ps-topo-svg {\n    display: block;\n    max-width: none;\n}\n.ps-topo-node { cursor: pointer; }\n.ps-topo-node-rect {\n    fill: #fff;\n    stroke: var(--border-color, #ccc);\n    stroke-width: 1;\n}\n.ps-topo-node:hover .ps-topo-node-rect { stroke: var(--accent-color, #06c); }\n.ps-topo-node-title {\n    font-family: monospace;\n    font-size: 12px;\n    fill: var(--text-primary, #333);\n    font-weight: 600;\n}\n.ps-topo-node-sub {\n    font-size: 10px;\n    fill: var(--text-secondary, #666);\n}\n.ps-topo-node-badge {\n    font-size: 9px;\n    fill: #a44;\n    text-transform: uppercase;\n}\n.ps-topo-edge { cursor: pointer; }\n.ps-topo-edge:hover path { stroke-width: 3; }\n.ps-topo-edge-label {\n    font-size: 9px;\n    fill: var(--text-secondary, #666);\n    font-family: monospace;\n    pointer-events: none;\n}\n\n/* Channel inspector */\n.ps-channel-snapshot {\n    margin: 8px 0;\n    font-size: 12px;\n}\n.ps-channel-tail-controls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 8px 0;\n    padding: 8px 0;\n    border-top: 1px solid var(--border-color, #eee);\n    border-bottom: 1px solid var(--border-color, #eee);\n}\n.ps-channel-tail-body {\n    max-height: 340px;\n    overflow-y: auto;\n    border: 1px solid var(--border-color, #eee);\n    border-radius: 4px;\n    background: var(--bg-primary, #fff);\n    margin-bottom: 8px;\n}\n\n/* ---- Prepare PR view (step 7) ---- */\n.ps-prepare-pr-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px 20px;\n}\n.ps-pr-intro {\n    font-size: 13px;\n    margin-bottom: 16px;\n    color: var(--text-secondary, #555);\n}\n.ps-pr-intro code {\n    background: #eef;\n    padding: 1px 6px;\n    border-radius: 3px;\n    font-size: 12px;\n}\n.ps-pr-section {\n    margin-bottom: 24px;\n}\n.ps-pr-section-title {\n    font-size: 13px;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    color: var(--text-secondary, #666);\n    margin: 0 0 8px;\n    padding-bottom: 4px;\n    border-bottom: 1px solid var(--border-color, #eee);\n}\n.ps-pr-card {\n    border: 1px solid var(--border-color, #ddd);\n    border-radius: 6px;\n    padding: 10px 12px;\n    margin-bottom: 10px;\n    background: var(--bg-primary, #fff);\n}\n.ps-pr-card-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 6px;\n    flex-wrap: wrap;\n}\n.ps-pr-card-title {\n    font-family: monospace;\n    font-weight: 600;\n    font-size: 13px;\n}\n.ps-pr-card-target {\n    font-size: 11px;\n    color: var(--text-secondary, #666);\n}\n.ps-pr-card-target code {\n    background: #eef;\n    padding: 1px 6px;\n    border-radius: 3px;\n    font-size: 11px;\n}\n.ps-pr-copy-btn { margin-left: auto; }\n.ps-pr-preview {\n    background: #1a1a2e;\n    color: #eee;\n    padding: 8px 12px;\n    border-radius: 4px;\n    font-family: monospace;\n    font-size: 11px;\n    max-height: 240px;\n    overflow: auto;\n    white-space: pre;\n    margin: 0;\n}\n.ps-pr-plugin-list {\n    margin: 0 0 8px;\n    padding-left: 20px;\n    font-size: 12px;\n}\n.ps-pr-plugin-list code {\n    background: #eef;\n    padding: 1px 6px;\n    border-radius: 3px;\n}\n\n/* ---- Feature Bundle view (import/export) ---- */\n.ps-bundle-body {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n.ps-bundle-tabs {\n    display: flex;\n    gap: 0;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n    padding: 0 16px;\n}\n.ps-bundle-tab {\n    padding: 8px 16px;\n    border: none;\n    background: none;\n    cursor: pointer;\n    font-size: 13px;\n    color: var(--text-secondary, #666);\n    border-bottom: 2px solid transparent;\n}\n.ps-bundle-tab.active {\n    color: var(--text-primary, #333);\n    border-bottom-color: var(--accent-color, #0066cc);\n    font-weight: 600;\n}\n.ps-bundle-tab-panel {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px 20px;\n}\n.ps-bundle-import-intro {\n    font-size: 13px;\n    color: var(--text-secondary, #555);\n    margin-bottom: 12px;\n}\n.ps-bundle-import-intro code {\n    background: #eef;\n    padding: 1px 6px;\n    border-radius: 3px;\n    font-size: 12px;\n}\n.ps-bundle-drop-zone {\n    border: 2px dashed var(--border-color, #ccc);\n    border-radius: 6px;\n    transition: border-color 0.15s;\n}\n.ps-bundle-drop-zone.drag-over {\n    border-color: var(--accent-color, #0066cc);\n}\n.ps-bundle-textarea {\n    width: 100%;\n    min-height: 160px;\n    resize: vertical;\n    font-family: monospace;\n    font-size: 12px;\n    box-sizing: border-box;\n    border: none;\n}\n.ps-bundle-import-row, .ps-bundle-export-controls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 12px 0;\n    flex-wrap: wrap;\n}\n.ps-bundle-import-row label, .ps-bundle-export-controls label {\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n}\n.ps-bundle-import-actions, .ps-bundle-export-actions {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 12px;\n}\n.ps-bundle-banner {\n    padding: 8px 12px;\n    border-radius: 4px;\n    font-size: 13px;\n    margin-bottom: 12px;\n}\n.ps-bundle-banner-ok {\n    background: #d4edda;\n    color: #155724;\n}\n.ps-bundle-banner-error {\n    background: #f8d7da;\n    color: #721c24;\n}\n.ps-bundle-meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n    margin-bottom: 12px;\n}\n.ps-bundle-meta code {\n    background: #eef;\n    padding: 1px 6px;\n    border-radius: 3px;\n}\n.ps-bundle-disposition-chip {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    padding: 1px 8px;\n    border-radius: 10px;\n    margin-left: auto;\n}\n.ps-bundle-disposition-applied {\n    background: #d4edda;\n    color: #155724;\n}\n.ps-bundle-disposition-verified {\n    background: #d1ecf1;\n    color: #0c5460;\n}\n.ps-bundle-disposition-carried {\n    background: #e2e3e5;\n    color: #41464b;\n}\n.ps-bundle-disposition-none {\n    background: #fff3cd;\n    color: #664d03;\n}\n.ps-bundle-section {\n    margin-bottom: 16px;\n}\n.ps-bundle-section-title {\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    color: var(--text-secondary, #666);\n    margin: 0 0 6px;\n    padding-bottom: 4px;\n    border-bottom: 1px solid var(--border-color, #eee);\n}\n.ps-bundle-rows {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n.ps-bundle-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 8px;\n    border-radius: 4px;\n    background: var(--bg-primary, #fff);\n    border: 1px solid var(--border-color, #eee);\n    font-size: 12px;\n}\n.ps-bundle-row code {\n    background: #eef;\n    padding: 1px 6px;\n    border-radius: 3px;\n}\n.ps-bundle-row-warn {\n    border-color: #ffe08a;\n    background: #fffaf0;\n}\n.ps-bundle-row-error {\n    border-color: #f5c2c7;\n    background: #fdf2f3;\n}\n.ps-bundle-row-type {\n    text-transform: uppercase;\n    font-size: 10px;\n    color: var(--text-secondary, #888);\n}\n.ps-bundle-row-code {\n    font-family: monospace;\n    color: #a94442;\n}\n.ps-bundle-row-reason {\n    flex-basis: 100%;\n    color: var(--text-secondary, #555);\n}\n.ps-bundle-error {\n    color: #a94442;\n    font-size: 13px;\n    padding: 8px 0;\n}\n.ps-bundle-raw-row {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n.ps-bundle-raw-details summary {\n    cursor: pointer;\n    font-size: 12px;\n    color: var(--text-secondary, #666);\n    margin-bottom: 6px;\n}\n.ps-bundle-raw {\n    background: #1a1a2e;\n    color: #eee;\n    padding: 8px 12px;\n    border-radius: 4px;\n    font-family: monospace;\n    font-size: 11px;\n    max-height: 320px;\n    overflow: auto;\n    white-space: pre;\n    margin: 0;\n}\n.ps-bundle-export-items {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    max-height: 320px;\n    overflow-y: auto;\n    border: 1px solid var(--border-color, #eee);\n    border-radius: 4px;\n    padding: 6px;\n    margin-bottom: 12px;\n}\n.ps-bundle-export-item-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    padding: 4px 6px;\n}\n.ps-bundle-export-item-row code {\n    background: #eef;\n    padding: 1px 6px;\n    border-radius: 3px;\n}\n.ps-bundle-feature-chip {\n    margin-left: auto;\n    font-size: 11px;\n    color: var(--text-secondary, #888);\n    background: var(--bg-secondary, #f0f0f0);\n    padding: 1px 8px;\n    border-radius: 10px;\n}\n\n/* ---- Clone-with-downstream modal (step 8) ---- */\n.ps-clone-downstream-list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    max-height: 300px;\n    overflow-y: auto;\n    border: 1px solid var(--border-color, #eee);\n    border-radius: 4px;\n    padding: 6px;\n}\n.ps-clone-downstream-row {\n    display: grid;\n    grid-template-columns: auto 1fr auto 1fr;\n    gap: 6px;\n    align-items: center;\n    font-size: 12px;\n}\n.ps-clone-downstream-row code {\n    background: #eef;\n    padding: 1px 6px;\n    border-radius: 3px;\n}\n.ps-clone-downstream-name { min-width: 160px; }\n\n/* ---- Shared picker-trigger styles (button that looks like a readonly input) ---- */\n.ps-picker-row {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    flex-wrap: wrap;\n}\n.ps-picker-display {\n    text-align: left;\n    cursor: pointer;\n    font-family: inherit;\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.ps-picker-display em {\n    color: var(--text-secondary, #888);\n    font-style: italic;\n}\n.ps-picker-display:hover {\n    background: var(--bg-hover, #f5f5f5);\n    border-color: var(--accent-color, #0066cc);\n}\n.ps-picker-display:focus {\n    outline: 2px solid var(--accent-color, #0066cc);\n    outline-offset: -2px;\n}\n\n.ps-picker-display .ps-picker-id {\n    color: var(--text-secondary, #888);\n    font-family: monospace;\n    font-size: 10px;\n    margin-left: 6px;\n    font-weight: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
